function init_administration_evaluation() {
    typeRegroupementInitPopover = function(nb, creation_time, where){
        let el = $(where).first()[0];
        if(typeof el === undefined){
            console.log('typeRegroupementInitPopover: Aucun élément trouvé pour le selecteur '+ $(where).selector);
            return;
        }
         ++typeRegroupementInitPopover.typeRegrouementPopoverId;
    };
    typeRegroupementInitPopover.typeRegroupementPopoverId=1;
    function municipaliteChanged() {
        content_pilotage_municipalite_loading = false;
        destroyDataTables();
        $('#content-historique-role').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-pilotage-municipalite').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-gestion-regroupement').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-onglet-zonage').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-extrant').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-voie-publique').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-importation-xml').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));
        $('#content-exportation').html('').append(getBanniereMessage('', "Sélectionner une municipalité"));

        var idMunicipalite = $('#adm-liste-ville').val();
        if (idMunicipalite) {
            admGetMunicipalite(idMunicipalite);
        }
    }

    $('#adm-liste-ville').select2();

    //Permet de charger la map avec la ville sélectionnée
    var selectMunicipalite = $('#adm-liste-ville');
    selectMunicipalite.on('change', function () {
        municipaliteChanged();
    });

    municipaliteChanged();
    $("#administration_onglets").find('li:first a').click();
    wait.stop();

    $('.tabbable').find('li > a').on('click', function (e) {
        chargerOngletAdministration($(this).closest('li'));
    });

    $('.tabbable').off('click', '#adm-btn-creer-role').on('click', '#adm-btn-creer-role', function (e) {
        var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "Voulez-vous vraiment créer un nouveau rôle pour " + municipalite + " ?",
            texteExplicatif: "",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.creerRoleEvaluation();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '#adm-btn-creer-voie-publique').on('click', '#adm-btn-creer-voie-publique', function (e) {
        evaluationAdministration.creerEditerVoiePublique();
    });

    $('.tabbable').off('click', '.editer-voie-publique').on('click', '.editer-voie-publique', function (e) {
        var voiePublique = $(e.currentTarget).attr('id_instance');
        evaluationAdministration.creerEditerVoiePublique(voiePublique);
    });

    $('.tabbable').off('click', '#adm-btn-creer-unite-voisinage').on('click', '#adm-btn-creer-unite-voisinage', function (e) {
        evaluationAdministration.creerEditerUniteVoisinage();
    });

    $('.tabbable').off('click', '#adm-btn-creer-zonage').on('click', '#adm-btn-creer-zonage', function (e) {
        evaluationAdministration.creerEditerZonage();
    });

    $('.tabbable').off('click', '#adm-btn-creer-profil-evaluateur-responsable').on('click', '#adm-btn-creer-profil-evaluateur-responsable', function (e) {
        profilEvaluateurResponsable.creerEditerProfilEvaluateurResponsable();
    });

    $('.tabbable').off('click', '.profil-evaluateur-responsable-edition').on('click', '.profil-evaluateur-responsable-edition', function (e) {
        const profilEvaluateur = $(e.currentTarget).data('id_instance');
        profilEvaluateurResponsable.creerEditerProfilEvaluateurResponsable(profilEvaluateur);
    });

     $('.tabbable').off('click', '.profil-evaluateur-responsable-suppression').on('click', '.profil-evaluateur-responsable-suppression', function (e) {
        const profilEvaluateur = $(e.currentTarget).data('id_instance');
        profilEvaluateurResponsable.modalSupprimerProfilEvaluateurResponsable(profilEvaluateur);
    });

    $('.tabbable').off('click', '.zonage-edition').on('click', '.zonage-edition', function (e) {
        evaluationAdministration.creerEditerZonage($(e.currentTarget).data('id_instance'));
    });
    $('.tabbable').off('click', '#adm-btn-ajouter-extrant').on('click', '#adm-btn-ajouter-extrant', function (e) {
        evaluationAdministration.ajouterExtrantMunicipalite();
    });
    $('.tabbable').off('click', '.extrant-suppression').on('click', '.extrant-suppression', function (e) {
        var extrant = $(e.currentTarget).data('id_instance');
        evaluationAdministration.initSuppressionExtrantMunicipalite(extrant);
    });
    $('.tabbable').off('click', '.extrant-edition').on('click', '.extrant-edition', function (e) {
        var extrant = $(e.currentTarget).data('id_instance');
        evaluationAdministration.ajouterExtrantMunicipalite(extrant);
    });
    $('.tabbable').off('click', '.unite-evaluation-edition').on('click', '.unite-evaluation-edition', function (e) {
        var uniteVoisinage = $(e.currentTarget).data('id_instance');
        var read_only = Boolean($(e.currentTarget).data('read_only'));
        evaluationAdministration.creerEditerUniteVoisinage(uniteVoisinage, read_only);
    });
    $('.tabbable').off('click', '.unite-evaluation-fiche-descriptive').on('click', '.unite-evaluation-fiche-descriptive', function (e) {
        var uniteVoisinageId = $(e.currentTarget).data('id_instance');
        evaluationAdministration.uniteVoisinageFicheDescriptive(uniteVoisinageId);
    });
    // # 9311, ET
    $('.tabbable').off('click', '#adm-btn-creer-role-xml').on('click', '#adm-btn-creer-role-xml', function (e) {
        evaluationAdministration.creerRoleXml();
    });

    $('.tabbable').off('click', '#adm-btn-importer-enquetes-ventes').on('click', '#adm-btn-importer-enquetes-ventes', function (e) {
        evaluationAdministration.importerEnquetesVentesAdHoc();
    });

    $('.tabbable').off('click', '#adm-btn-supprimer-municipalite').on('click', '#adm-btn-supprimer-municipalite', function (e) {
        var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "ATTENTION !!!",
            texteExplicatif: "Toute la municipalité " + municipalite + ", incluant UEs, bâtiments et évènements, sera supprimée de façon irréversible ! Continuer ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.supprimerMunicipalite();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '#adm-btn-post-importation').on('click', '#adm-btn-post-importation', function (e) {
        //var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "Rouler les scripts post importation",
            texteExplicatif: "Continuer ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.postImportation();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '[name=adm-btn-importer-document]').on('click', '[name=adm-btn-importer-document]', function (e) {
        fenetreModal.modalMessage({
            titre: "Importer les documents",
            texteExplicatif: "Continuer ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.importerDocument();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '[name=adm-btn-importer-selectionnes]').on('click', '[name=adm-btn-importer-selectionnes]', function (e) {
        evaluationAdministration.importerSelectionnes(false);
    });

    $('.tabbable').off('click', '[name=adm-btn-motif-prive]').on('click', '[name=adm-btn-motif-prive]', function (e) {
        evaluationAdministration.importerSelectionnes(true);
    });

    $('.tabbable').off('click', '[name=adm-btn-balancer-sommaire]').on('click', '[name=adm-btn-balancer-sommaire]', function (e) {
        //var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "Balancer le sommaire",
            texteExplicatif: "Continuer ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.balancerSommaire();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '[name=adm-btn-importer-total]').on('click', '[name=adm-btn-importer-total]', function (e) {
        //var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "Importer TOTAL",
            texteExplicatif: "Ceci supprimera la mun et la réimportera au COMPLET. Continuer ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.importerTotal();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '[name=adm-btn-importer-custom]').on('click', '[name=adm-btn-importer-custom]', function (e) {
        var bouton = $(this);
        var importAction = bouton.attr('import-action');

        //var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "Importer Custom",
            texteExplicatif: "Action: "+importAction+". Continuer ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.importerCustom(importAction);
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '[name=adm-btn-exportation]').on('click', '[name=adm-btn-exportation]', function (e) {
        var municipalite = $('#adm-liste-ville').select2('data').text;
        fenetreModal.modalMessage({
            titre: "Exportation",
            texteExplicatif: "Exporter la municipalité " + municipalite + " ?",
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        evaluationAdministration.finContratExportation();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                    }
                }
            }
        });
    });

    $('.tabbable').off('click', '#btn-administration-modal-creer-type-regroupement').on('click', '#btn-administration-modal-creer-type-regroupement', function (e) {
        creerEditerTypeRegroupement();
    });

    $('#content-gestion-regroupement').off('click', 'td a').on('click', 'td a', function (e) {
        var btn = $(this).attr('class');
        if (btn === 'editer-regroupement') {
            creerEditerTypeRegroupement(
                $(e.currentTarget).data('id_type_regroupement'),
                $(e.currentTarget).data('bool_regroupement_base'),
                $(e.currentTarget).data('modal-titre')
            );
        }else if(btn === 'copier-regroupement'){
            wait.start();
            let municipalite_id = $('#adm-liste-ville').val();
            let type_regroupement_id = $(e.currentTarget).data('id_type_regroupement');
            let url_copier_regroupement = "/gestion-roles/regroupement/copier-regroupement/"+municipalite_id+"/"+type_regroupement_id;
            $.ajax({
                type: "GET",
                url: url_copier_regroupement,
                dataType: 'json',
                success: function (response) {
                    wait.stop();
                    if(response){
                        infos.ajouterMessageToast({
                            message: "Regroupement copié avec succès<br/> Le regroupement '"+response.type_regroupement_description+"' <br/> Va s'ouvrir dans un instant",
                            messageDuree: 5000,
                            messageCouleur: "green"
                        });
                        creerEditerTypeRegroupement(response.type_regroupement_pk, false, 'Editer le nouveau regroupement');
                    }else{
                        infos.ajouterMessageToast({
                            message: "Erreur de copie du regroupement. Contacter un administrateur.",
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                    }

                }
            });
        }
    });
}

function chargerOngletAdministration(li) {
    if (li.attr('charge') == 'true') {
        return;
    }

    setTimeout(function () {
        initRapportSectionsVisibles();

        var idOnglet = li.find('> a').attr('id');
        var idMunicipalite = $('#adm-liste-ville').val();
        const organisation_id = $('#content-pilotage-profils-evaluateur-responsable').data('organisation')

        if (idOnglet == 'historique-role') {
            tableHistoriqueRole(idMunicipalite);
        }
        if (idOnglet == 'pilotage-municipalite' && idMunicipalite != '') {
            admGetContentPilotageMunicipalite(idMunicipalite);
        }

        if (idOnglet == 'extrant') {
            if (!$.fn.DataTable.isDataTable('#adm-table-extrant')) {
                evaluationAdministration.importerDataTableTableExtrant();
            }
        }
        if (idOnglet == 'voie-publique') {
            if (!$.fn.DataTable.isDataTable('#adm-table-pilotage')) {
                evaluationAdministration.importerDataTableTablePilotage();
            }
        }

        if (idOnglet == 'importation-xml') {
            admGetContentImportationXml(idMunicipalite);
        }

        if (idOnglet == 'onglet-zonage') {
            importerDataTableZonage();
        }
        if (idOnglet == 'gestion-regroupement') {
            $('.table-evenements').css('width', '100%');
        }

        if (idOnglet == 'onglet-profil-evaluateur'){
            profilEvaluateurResponsable.admGetContentProfilEvaluateurResponsable(organisation_id)
        }

        // click sur l'onglet pilotage municipalité
        // $('a[href=#content-pilotage-municipalite]').on('click', function (e) {
        //     if(!content_pilotage_municipalite_loading && idMunicipalite){
        //         admGetContentPilotageMunicipalite(idMunicipalite);
        //         content_pilotage_municipalite_loading=true;
        //     }
        // });


        li.attr('charge', 'true');
    }, 500);
}

function ajouterExtrantMunicipalite(extrant) {
    var idExtrant = '';
    if (extrant) {
        idExtrant = extrant + '/';
    }
    var idmunicipalite = $('#adm-liste-ville').val(); // HACK !
    var params ={'id_municipalite':idmunicipalite};
    var tablePilotageExtrant = {
        id: "extrant-municipalite",
        view: "/core/modal/",
        processus_id: "",
        titre: "Table de Gestion des extrants",
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "", //modal-inside-assigne-a.html
        template_view: "/gestion-roles/extrant-municipalite/"+idExtrant,
        template_depart: "",
        sans_x: true,
        template_depart_view: "",
        url: "",
        taille: "normal",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Annuler",
                title: "",
                classSupp: "",
                afficher: true
            },

            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: true,
                id: "btn-save-extrant-municipalite",
                disabled: false
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            controlesFormulaires.redimentionnerTextarea();
        }, function () {
            $('#typeDocument').select2();
        }];
        fenetreModal.creerModal(tablePilotageExtrant, params, callbacks);
    }, 0);
}

 function sauvegarderExtrantMunicipalite(paramsSupp) {
      wait.start();
    var idMunicipalite = $('#adm-liste-ville').val(); // HACK !
    var params = [
        {'name': 'municipalite', 'value': idMunicipalite}
    ];

    var formulaireDonnees = controlesFormulaires.serialiserFormulaire($('#table-extrants-details'));
    params = params.concat(paramsSupp);
    params = params.concat(formulaireDonnees);
    var jqxhr = $.ajax({
        url: '/gestion-roles/administration-evaluation/save-extrant/',
        async: false,
        dataType: 'json',
        type:'POST',
        data: params
    });
    jqxhr
        .done(function (response) {
            refreshDatatables(function () {
                if ($('#typeDocument').length > 0) {
                    fenetreModal.fermerModal('extrant-municipalite');
                }
                wait.stop();
                $('#adm-table-pilotage input.switch').lc_switch('Actif', '');
            });
             infos.ajouterMessageToast({
                message: 'Sauvegarde réussie',
                messageDuree: 500,
                icone: 'fa-check-circle-o',
                iconeCouleur: 'green'
            });
        });
    jqxhr
        .fail(function (xhr, textStatus, errorThrown) {

            infos.ajouterMessageToast({
                message: 'Erreur de sauvegarde',
                messageCouleur: 'red'
            });
            wait.stop();
        });
}

function initSuppressionExtrantMunicipalite(extrant) {
                fenetreModal.modalMessage({
                    titre: "Voulez-vous vraiment enlever cet extrant de la liste prescrite  ?",
                    texteExplicatif: "Ceci aura pour effet de l'enlever dans les extrants cochés par défaut dans la fermeture de cycle.",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                // mettre un timeout au cas ou cette fonction ferait afficher un autre modal, car les modals sont automatiquement fermés sur clique d'un bouton
                    wait.start();
                var paramsfact = {
                            "id_extrant": extrant,
                        };
        $.ajax({
            type: "GET",
            url: "/gestion-roles/administration-evaluation/supprimer-extrant/",
            data: paramsfact,
            dataType: 'json',
            success: function (response) {
                refreshDatatables(function () {
                    if ($('#typeDocument').length > 0) {
                        fenetreModal.fermerModal('extrant-municipalite');
                    }
                    wait.stop();
                    $('#adm-table-pilotage input.switch').lc_switch('Actif', '');
                });
            infos.ajouterMessageToast({
                                            message: 'Extrant enlevé avec reussie',
                                            messageDuree: 500,
                                            icone: 'fa-check-circle-o',
                                                iconeCouleur: 'green'
                                        });
                                        wait.stop();
            }
        });







                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }

                });

        }

var evaluationAdministrationBoutons = {
    initEvenementsJQuery: function () {
        $('#adm-table-pilotage').off("click", 'div.lcs_switch:not(".lcs_disabled")').on("click", 'div.lcs_switch:not(".lcs_disabled")', function (e) {
            var valeur = $(this).hasClass('lcs_on') ? 'lcs_off' : 'lcs_on';
            var parametres = [
                {'name': 'methode', 'value': 'PATCH'},
                {'name': 'bool', 'value': valeur},
                {'name': 'id', 'value': $(e.target).closest('tr').find('td:eq(0)').text()},
            ];
            evaluationAdministration.sauvegarderVoiePublique(parametres);
        });
        $('body').off('click', '#btn-save-modal-pilotage').on('click', '#btn-save-modal-pilotage', function (e) {
            var voiePublique = $('#table-pilotage-details').attr('id-model-instance');
            var methode = 'POST';
            if (voiePublique.length > 0 && voiePublique !== 'None') {
                methode = 'PATCH';
            }
            var parametres = [{'name': 'methode', 'value': methode}];
            evaluationAdministration.sauvegarderVoiePublique(parametres);
        });
         $('body').off('click', '#btn-save-extrant-municipalite').on('click', '#btn-save-extrant-municipalite', function (e) {
             var idExtrant = $('#table-extrants-details').attr('id-model-instance');
             var parametres = [{'name': 'idExtrant', 'value': idExtrant}];

             evaluationAdministration.sauvegarderExtrantMunicipalite(parametres);
        });
    }
}; // namespace tenueAJourBoutons

var evaluationAdministration = (function () {

    function creerRoleEvaluation() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/creer-role/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
                municipaliteChanged(); // rafraichir
            }
        });
    }

    function importerDataTableTableVoisinage(idRole) {
        var id_municipalite = $('#adm-liste-ville').select2('val');
        //    On charge les voies publiques et on affiche
        var nomTableDataTable = 'adm-table-voisinage';
        var $tableDataTable = $('#' + nomTableDataTable);
        if ( $.fn.dataTable.isDataTable($tableDataTable) ){
            return;
        }

        var tableVoisinage = initTableDatatable($tableDataTable, {
            ajax: {
                url: '/gestion-roles/administration-evaluation/municipalite/' + encodeURIComponent(id_municipalite) + '/unites-voisinage/'+ idRole + '/',
                data: function (d) {
                    // d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                }
            },
            async: false, // Si True, les listes des filtres s'écrasent dans la dernière liste de sélection puisque la
            // génération des boutons arrive après la fin de l'exécution ajax.
            order: [[1, 'asc']],
            processing: false,
            scrollX: false,
            searching: true,
            columnDefs: [
                {
                    title: "Unité de voisinage",
                    targets: 0,
                    data: "unicode"
                },
                {
                    title: "Date début",
                    targets: 1,
                    data: "date_debut",
                    sortable: true,
                    render: function (data, type, row) {
                        if (data !== null) {
                            var date = data.split('T')[0];
                            return date;
                        } else {
                            return data;
                        }
                    }
                },
                {
                    title: "Date fin",
                    targets: 2,
                    data: "date_fin",
                    sortable: true,
                    render: function (data, type, row) {
                        if (data !== null) {
                            var date = data.split('T')[0];
                            return date;
                        } else {
                            return data;
                        }
                    }
                },
                {
                    title: "Nb. de Regroupement affectés",
                    targets: 3,
                    data: "nb_regroup",
                    sortable: false,

                },
                {
                    title: "Actions",
                    targets: 4,
                    data: "actions",
                    sortable: false
                },
            ],

            initComplete: function (settings, json) {
                $('.tabbable #' + nomTableDataTable + '_filter input[type=search]').keyup(function () {
                    var table = $tableDataTable.DataTable();
                    table.search(
                        jQuery.fn.DataTable.ext.type.search.string(this.value)
                    ).draw();
                });
                $('#adm-table-voisinage').on('search.dt', function () {
                    $('#adm-table-voisinage').find('input.switch').lc_switch('Actif', '');
                });
                //#15694 : pour afficher le détail des regroupements de l'uv
                $(document).on('click', '.lien-ligne-uv-liste-regroupement', function(e) {
                    modalTypeRegroupementDansUV($(this).data('lien'));
                });


            }
        });
        $(tableVoisinage).on('processing.dt', function (e, settings, processing) {
            wait.processing(processing, '', '', 0);
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
    }

    function importerDataTableTablePilotage() {
        var id_municipalite = $('#adm-liste-ville').select2('val');
        var nomTableDataTable = 'adm-table-pilotage';
        var $tableDataTable = $('#' + nomTableDataTable);
        var tablePilotage = initTableDatatable($tableDataTable, {
            ajax: {
                url: '/gestion-roles/administration-evaluation/municipalite/' + encodeURIComponent(id_municipalite) + '/voies-publiques/',
                data: function (d) {
                    // d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                }
            },
            async: false, // Si True, les listes des filtres s'écrasent dans la dernière liste de sélection puisque la
            // génération des boutons arrive après la fin de l'exécution ajax.
            order: [[1, 'asc']],
            processing: false,
            scrollX: false,
            responsive: false,
            searching: true,
            rowId: 'id_voie_publique',
            columnDefs: [
                {
                    "targets": 1,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).attr('name', 'nom');
                    }
                },
                {
                    title: "ID",
                    targets: 0,
                    data: "id_voie_publique"
                },
                {
                    title: "Voie publique",
                    targets: 1,
                    data: "unicode",
                    className: 'form-control',
                },
                {
                    title: "État",
                    targets: 2,
                    data: "bool_actif",
                    sortable: false
                },
                {
                    targets: 2,
                    width: "60px",
                    data: null,
                    render: function (data, type, row) {
                        var etat = (data == true || data == null) ? 'checked' : '';
                        let can_edit = $("#adm-table-pilotage").data('can_edit') == 'True';
                        let html = can_edit ? '' : 'disabled';
                        return '<div class="action-buttons align-middle align-center"><input type="checkbox" name="etat" id-model-instance="' + row.id_voie_publique + '" class="activer-voie-publique switch" value="' + data + '" ' + etat + ' ' + html + '></div>';
                    }
                }
            ],
            drawCallback: function (settings) {
                $('#adm-table-pilotage').find('input.switch').lc_switch('Actif', '');
            },
            initComplete: function (settings, json) {
                evaluationAdministrationBoutons.initEvenementsJQuery();
                $('.tabbable #' + nomTableDataTable + '_filter input[type=search]').keyup(function () {
                    var table = $tableDataTable.DataTable();
                    table.search(
                        jQuery.fn.DataTable.ext.type.search.string(this.value)
                    ).draw();
                });
                $('#adm-table-pilotage').on('search.dt', function () {
                    $('#adm-table-pilotage').find('input.switch').lc_switch('Actif', '');
                });
            }
        });
        $(tablePilotage).on('processing.dt', function (e, settings, processing) {
            wait.processing(processing, '', '', 0);
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
    }

    function importerDataTableTableExtrant() {
        var id_municipalite = $('#adm-liste-ville').select2('val');
        var nomTableDataTable = 'adm-table-extrant';
        var $tableDataTable = $('#' + nomTableDataTable);
        function formatCheckbox(data, row) {
          var etat = (data === true) ? 'checked' : '';
          return '<div class="action-buttons align-middle align-center"><input type="checkbox" name="etat" id-model-instance="' + row.id_extrant + '" disabled class="activer-voie-publique switch" value="' + data + '" ' + etat + '/></div>';
        }

        var columnTitles = ["Type document", "Livrable centre scolaire", "Fermeture de cycle", "Dépôt de rôle", "Obligatoire", "Actions"];
        var columnDataProps = ["id_type_document", "bool_livrable_cs", "bool_fermeture_cycle", "bool_depot_role", "bool_obligatoire", "actions"];
        var columnSortable = [true, false, false, false, false, false];
        var columnRenderFuncs = [null, formatCheckbox, formatCheckbox, formatCheckbox, formatCheckbox, null];

        var columnDefs = columnTitles.map((title, i) => {
          return {
            title: title,
            targets: i,
            data: columnDataProps[i],
            sortable: columnSortable[i],
            render: columnRenderFuncs[i]
          };
        });

        tablePilotageExtrant = initTableDatatable($tableDataTable, {
            ajax: {
                url: '/gestion-roles/administration-evaluation/municipalite/' + encodeURIComponent(id_municipalite) + '/extrants-municipalite/',
                data: function (d) {
                }
            },
            async: false,
            order: [[1, 'asc']],
            processing: false,
            scrollX: false,
            responsive: false,
            searching: true,
            rowId: 'id_extrant',
            columnDefs: columnDefs,
            drawCallback: function (settings) {
                $('#adm-table-extrant').find('input.switch').lc_switch('Actif', '');
            },
            initComplete: function (settings, json) {
                evaluationAdministrationBoutons.initEvenementsJQuery();
                $('.tabbable #' + nomTableDataTable + '_filter input[type=search]').keyup(function () {
                    var table = $tableDataTable.DataTable();
                    table.search(
                        jQuery.fn.DataTable.ext.type.search.string(this.value)
                    ).draw();
                });
            }
        });
        $(tablePilotageExtrant).on('processing.dt', function (e, settings, processing) {
            wait.processing(processing, '', '', 0);
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
    }






    function modalSupprimerUV(idUniteVoisinage) {
        var variableSupprimerUv = {
            id: "uv-supprimer-modal",
            view: "/core/modal/",
            id_processus: "",
            titre: "Souhaitez-vous vraiment supprimer cette unité de voisinage?",
            titre_supp: "",
            module: "",
            contenuHTML: '<h5 class="modal-title red vertical-align-middle">Les données seront détruites de façon permanente</h5><p>',
            contenuIcone: 'fa-exclamation-triangle orange vertical-align-middle',
            template: "",
            template_view: "",
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "normale",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            sans_x: true,
            callback: function (e) {
                setTimeout(function () {
                    $('#proceder-supprimer-uv').off('click').on('click', function () {
                        modalSupprimerUVConfirmed(idUniteVoisinage);
                    });
                }, 100);
            },
            boutons: [
                {
                    type: "delete",
                    label: "Oui",
                    title: "",
                    classSupp: "btn-danger",
                    afficher: true,
                    id: "proceder-supprimer-uv",
                },
                {
                    type: "cancel",
                    label: "Non",
                    title: "",
                    classSupp: "",
                    afficher: true
                }
            ]
        };

        setTimeout(function () {
            $('#supprimer-uv').off('click').on('click', function () {
                fenetreModal.creerModal(variableSupprimerUv, {});
            });
        }, 100);
    }

    function modalTypeRegroupementDansUV(url) {
        //#15694
        var modalTypeRegroupementDansUVConfig = {
            id: "modalTypeRegroupementDansUV",
            view: "/core/modal/",
            titre: "Liste des regroupements de cette UV",
            template_view: url,
            sans_x: false,
            url: "",
            taille: "normal",
            wizard: false,
            boutons: [
                {
                    type: "cancel",
                    label: "ok",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
            ]
        };
        setTimeout(function () {
            fenetreModal.creerModal(modalTypeRegroupementDansUVConfig, {});
        }, 0);
    }

    function modalSupprimerUVConfirmed(idUniteVoisinage) {
        let current_role = $('#current-role').val();
        var params = {
            current_role: current_role,
        };

        wait.start();

        var jqxhr = $.ajax({
            type: "DELETE",
            url: "/gestion-roles/unites-voisinage/" + idUniteVoisinage,
            data: params,
            dataType: 'html'
        });
        jqxhr
            .done(function (response) {
                var reponse = JSON.parse(response);
                if (reponse.response == 'ok') {
                    refreshDatatables();

                    fenetreModal.fermerModal("uv-supprimer-modal");
                    fenetreModal.fermerModal("unites-voisinage");
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: reponse.message,
                        messageDuree: 5000
                    });
                } else {
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', reponse.message);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        messageCouleur: 'red',
                        messageDuree: 5000
                    });
                }
                wait.stop();
            });
        jqxhr
            .fail(function (jqxhr, textStatus, errorThrown) {
                erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: "Erreur de suppression d'évènement",
                    messageDuree: 5000,
                    messageCouleur: "red"
                });
                $('#proceder-supprimer-evenement').remove();
                $('[data-dismiss="modal-fermer"]').prop('innerText', 'Fermer');
                wait.stop();
            });
    }



    function uniteVoisinageFicheDescriptive(uniteVoisinageId) {
        var callback_uniteVoisinageFicheDescriptive = function () {
            $('#unite-voisinage-fiche-descriptive-bouton-imprimer').off('click').on('click', function (e) {
                let print_url = "/gestion-roles/administration-evaluation/municipalite/"+$('#adm-liste-ville').val()+"/unite-voisinage-fiche-descriptive/" + uniteVoisinageId+'/print';
                window.open(print_url, '_blank');
            });
        };
        let modal_uv_desc = {
            id: "unite-voisinage-fiche-descriptive",
            view: "/core/modal/",
            titre: "Unité de voisinage: fiche descriptive",
            template_view: "/gestion-roles/administration-evaluation/municipalite/"+$('#adm-liste-ville').val()+"/unite-voisinage-fiche-descriptive/" + uniteVoisinageId,
            taille: "immense",
            wizard: false,
            sans_x: false,
            callback: callback_uniteVoisinageFicheDescriptive,
            boutons: [
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
                {
                    type: "print",
                    label: "Imprimer",
                    id: "unite-voisinage-fiche-descriptive-bouton-imprimer",
                    afficher: true
                }
            ]
        };
        fenetreModal.creerModal(modal_uv_desc, {});
    }

    function creerEditerUniteVoisinage(uniteVoisinage=false, read_only=false) {
        var idUniteVoisinage = '';
        if (uniteVoisinage) {
            idUniteVoisinage = uniteVoisinage + '/';
        }
        var tableVoisinage = {
            read_only: read_only,
            idUniteVoisinage: uniteVoisinage,
            id: "unites-voisinage",
            view: "/core/modal/",
            processus_id: "",
            titre: "Unité de voisinage",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template: "", //modal-inside-assigne-a.html
            template_view: "/gestion-roles/unites-voisinage/" + idUniteVoisinage,
            template_depart: "",
            sans_x: true,
            template_depart_view: "",
            url: "",
            taille: "normal",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            boutons: [
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
                {
                    type: "delete",
                    label: "Supprimer",
                    title: "",
                    classSupp: "",
                    afficher: Boolean(!read_only && uniteVoisinage),
                    id: "supprimer-uv",
                },
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "",
                    classSupp: "btn-primary",
                    afficher: !read_only,
                    id: "btn-save-modal-voisinage",
                    disabled: false
                }
            ]
        };
        setTimeout(function () {
            var callbacks = [
            function () {
                controlesFormulaires.redimentionnerTextarea();
            },
            function () {
                if(!idUniteVoisinage){
                    // On insère l'année du rôle sélectionné comme date de début
                    $('#unites-voisinage').find('[name="date_debut"]').val($('#current-role-annee').val()+'-01-01');
                }
                function enregistrer_uv(){
                    var uniteVoisinage = $('#table-voisinage-details').attr('id-model-instance');
                    var methode = 'POST';
                    if (uniteVoisinage.length > 0 && uniteVoisinage !== 'None') {
                        methode = 'PATCH';
                    }
                    var parametres = [{'name': 'methode', 'value': methode}];
                    evaluationAdministration.sauvegarderUniteVoisinage(parametres);
                }
                function ajax_get_nb_typeregroup_x_uv(){
                    wait.start();
                    let nb = 0;
                    let id_role = $('#current-role').val();
                    let id_unite_voisinage = tableVoisinage['idUniteVoisinage'];
                    $.ajax({
                        type: "GET",
                        async:false,
                        url: "/gestion-roles/administration-evaluation/get-unite-voisinage-x-regroupement-nb/"+id_unite_voisinage+"/"+id_role+"/",
                        dataType: 'json',
                        success: function (response) {
                            if(response){
                                nb=parseInt(response);
                            }
                            wait.stop();
                        }
                    });
                    return nb;
                }
                modalSupprimerUV(idUniteVoisinage);
                $('body').off('click', '#btn-save-modal-voisinage').on('click', '#btn-save-modal-voisinage', function (e) {
                    var nb;
                    if(idUniteVoisinage){
                        nb=0;
                    }else{
                        nb = ajax_get_nb_typeregroup_x_uv();
                    }
                    if(nb>0){
                        fenetreModal.modalMessage({
                            enteteTitre: 'Attention',
                            titre: "Cette unité de voisinage est utilisée dans ["+nb+"] regroupements. ",
                            texteExplicatif: "Etes-vous sur de vouloir enregistrer les changements?",
                            texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
                            conteneur: "#unites-voisinage",
                            taille: "grande",
                            boutons: {
                                "Oui": {
                                    label: " Oui ", id: "", class: "btn btn-success",
                                    action: function () {
                                        enregistrer_uv();
                                    }
                                },
                                "Non": {
                                    label: " Non ", id: "", class: "btn",
                                    action: function () {fenetreModal.fermerModalAlerteDivs();}
                                }
                            }
                        }); //fenetreModal
                    }else{
                        enregistrer_uv();
                    }

                }); // on click btn-save-modal-voisinage

            }, function () {
                $('#unites-voisinage').find('select').select2();
            }];
            // TODO: Valider les autorisations et afficher un message correspondant
            fenetreModal.creerModal(tableVoisinage, {}, callbacks);
        }, 0);
    }

    function creerEditerZonage(zonage=false, read_only=false) {
        var idZonage = '';
        if (zonage) {
            idZonage = zonage + '/';
        }
        var tableZonage = {
            read_only: read_only,
            idZonage: zonage,
            id: "zonage",
            view: "/core/modal/",
            processus_id: "",
            titre: "Zonage",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template: "", //modal-inside-assigne-a.html
            template_view: "/gestion-roles/zonage/" + idZonage,
            template_depart: "",
            sans_x: true,
            template_depart_view: "",
            url: "",
            taille: "normal",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            boutons: [
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "",
                    classSupp: "btn-primary",
                    afficher: !read_only,
                    id: "btn-save-modal-zonage",
                    disabled: false
                }
            ]
        };
        setTimeout(function () {
            var callbacks = [
            function () {
                controlesFormulaires.redimentionnerTextarea();
            },
            function () {
                if(!idZonage){
                    $('#zonage').find('[name="date_debut"]').data('daterangepicker').setStartDate(new Date());
                    $('#zonage').find('[name="date_debut"]').val(moment().format('YYYY-MM-DD'));
                }
                function enregistrer_zonage(){
                    var uniteVoisinage = $('#table-zonage-details').attr('id-model-instance');
                    var methode = 'POST';
                    if (uniteVoisinage.length > 0 && uniteVoisinage !== 'None') {
                        methode = 'PATCH';
                    }
                    var parametres = [{'name': 'methode', 'value': methode}];
                    evaluationAdministration.sauvegarderZonage(parametres);
                }
                $('body').off('click', '#btn-save-modal-zonage').on('click', '#btn-save-modal-zonage', function (e) {
                    enregistrer_zonage();
                });

            }];
            fenetreModal.creerModal(tableZonage, {}, callbacks);
        }, 0);
    }

    function creerEditerVoiePublique(voiePublique) {
        var idVoiePublique = '';
        if (voiePublique) {
            idVoiePublique = voiePublique + '/';
        }
        var tablePilotage = {
            id: "voies-publiques",
            view: "/core/modal/",
            processus_id: "",
            titre: "Table de pilotage",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template: "", //modal-inside-assigne-a.html
            template_view: "/gestion-roles/voies-publiques/" + idVoiePublique,
            template_depart: "",
            sans_x: true,
            template_depart_view: "",
            url: "",
            taille: "normal",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            boutons: [
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },

                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "",
                    classSupp: "btn-primary",
                    afficher: true,
                    id: "btn-save-modal-pilotage",
                    disabled: false
                }
            ]
        };
        setTimeout(function () {
            var callbacks = [function () {
                controlesFormulaires.redimentionnerTextarea();
            }, function () {
                $('#voies-publiques').find('select').select2();
            }];
            // TODO: Valider les autorisations et afficher un message correspondant
            fenetreModal.creerModal(tablePilotage, {}, callbacks);
        }, 0);
    }

    function sauvegarderUniteVoisinage(paramsSupp) {
        wait.start();
        var idMunicipalite = $('#adm-liste-ville').val(); // HACK !
        var params = [
            {'name': 'municipalite', 'value': idMunicipalite}
        ];
        var id;
        if (estKeyInArrayOfObjects(paramsSupp, 'bool')) {
            var bool_actif = reqValeurKeyInArrayOfObjects(paramsSupp, 'bool').value === 'lcs_on' ? 'True' : 'False';
            params.push({'name': 'bool_actif', 'value': bool_actif});
            id = reqValeurKeyInArrayOfObjects(paramsSupp, 'id').value;
        } else {
            id = $('#table-voisinage-details').attr('id-model-instance');
        }

        var formulaireDonnees = controlesFormulaires.serialiserFormulaire($('#table-voisinage-details'));

        params = params.concat(paramsSupp);
        params = params.concat(formulaireDonnees);
        // var parametres = tenueAJourModal.nettoyerParams(params);

        var element = id.length > 0 && id !== 'None' ? encodeURIComponent(id) + '/' : '';
        var jqxhr = $.ajax({
            url: '/gestion-roles/unites-voisinage/' + element,
            async: true,
            type: reqValeurKeyInArrayOfObjects(paramsSupp, 'methode').value,
            dataType: 'json',
            data: params
        });
        jqxhr
            .done(function (response) {
                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });
                refreshDatatables(function () {
                    if ($('#unites-voisinage').length > 0) {
                        fenetreModal.fermerModal('unites-voisinage');
                    }
                    wait.stop();
                    $('#adm-table-voisinage input.switch').lc_switch('Actif', '');
                });
            });
        jqxhr
            .fail(function (xhr, textStatus, errorThrown) {
                erreursAjax.effacerErreurChamps($('#unites-voisinage'));
                erreursAjax.traiterErreurs($('#unites-voisinage'), xhr, errorThrown);
                // erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', xhr, errorThrown);
                infos.ajouterMessageToast({
                    message: 'Erreur de sauvegarde',
                    messageCouleur: 'red'
                });
                wait.stop();
            });

    }

    function sauvegarderZonage(paramsSupp) {
        wait.start();
        var idMunicipalite = $('#adm-liste-ville').val(); // HACK !
        var params = [
            {'name': 'municipalite', 'value': idMunicipalite}
        ];
        var id;
        if (estKeyInArrayOfObjects(paramsSupp, 'bool')) {
            var bool_actif = reqValeurKeyInArrayOfObjects(paramsSupp, 'bool').value === 'lcs_on' ? 'True' : 'False';
            params.push({'name': 'bool_actif', 'value': bool_actif});
            id = reqValeurKeyInArrayOfObjects(paramsSupp, 'id').value;
        } else {
            id = $('#table-zonage-details').attr('id-model-instance');
        }

        var formulaireDonnees = controlesFormulaires.serialiserFormulaire($('#table-zonage-details'));

        params = params.concat(paramsSupp);
        params = params.concat(formulaireDonnees);

        var element = id.length > 0 && id !== 'None' ? encodeURIComponent(id) + '/' : '';
        var jqxhr = $.ajax({
            url: '/gestion-roles/zonage/' + element,
            async: true,
            type: reqValeurKeyInArrayOfObjects(paramsSupp, 'methode').value,
            dataType: 'json',
            data: params
        });
        jqxhr
            .done(function (response) {
                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });
                refreshDatatables(function () {
                    if ($('#zonage').length > 0) {
                        fenetreModal.fermerModal('zonage');
                    }
                    wait.stop();
                    $('#adm-table-zonage input.switch').lc_switch('Actif', '');
                });

            });
        jqxhr
            .fail(function (xhr, textStatus, errorThrown) {
                erreursAjax.effacerErreurChamps($('#zonage'));
                erreursAjax.traiterErreurs($('#zonage'), xhr, errorThrown);
                infos.ajouterMessageToast({
                    message: 'Erreur de sauvegarde',
                    messageCouleur: 'red'
                });
                wait.stop();
            });

    }

    function sauvegarderVoiePublique(paramsSupp) {
        wait.start();
        var idMunicipalite = $('#adm-liste-ville').val(); // HACK !
        var params = [
            {'name': 'municipalite', 'value': idMunicipalite}
        ];
        var id;
        if (estKeyInArrayOfObjects(paramsSupp, 'bool')) {
            var bool_actif = reqValeurKeyInArrayOfObjects(paramsSupp, 'bool').value === 'lcs_on' ? 'True' : 'False';
            params.push({'name': 'bool_actif', 'value': bool_actif});
            id = reqValeurKeyInArrayOfObjects(paramsSupp, 'id').value;
        } else {
            id = $('#table-pilotage-details').attr('id-model-instance');
        }
        var formulaireDonnees = controlesFormulaires.serialiserFormulaire($('#table-pilotage-details'));
        params = params.concat(paramsSupp);
        params = params.concat(formulaireDonnees);
        var element = id.length > 0 && id !== 'None' ? encodeURIComponent(id) + '/' : '';
        var rowID = encodeURIComponent(id);
        var jqxhr = $.ajax({
            url: '/gestion-roles/voies-publiques/' + element,
            async: false,
            type: reqValeurKeyInArrayOfObjects(paramsSupp, 'methode').value,
            dataType: 'json',
            data: params
        });
        jqxhr
            .done(function (response) {
                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });
                refreshDatatables(function () {
                    if ($('#voies-publiques').length > 0) {
                        fenetreModal.fermerModal('voies-publiques');
                    }
                    wait.stop();
                    $('#adm-table-pilotage input.switch').lc_switch('Actif', '');
                });
            });
        jqxhr
            .fail(function (xhr, textStatus, errorThrown) {

                erreursAjax.effacerErreurChamps($('#' + rowID));
                erreursAjax.traiterErreurs($('#' + rowID), xhr, errorThrown);
                // Parce qu'on est dans une table où on simule un input comme un display table-cell, on replace le div à la fin du contenu du TD. Normalement, on n'a pas ce problème dans un contexte d'un vrai input.
                var contenu = $('#' + rowID).find('.form-control');
                var messageErreur = $('#' + rowID).find('.message-erreur');
                contenu.append(messageErreur);


                erreursAjax.effacerErreurChamps($('#voies-publiques'));
                erreursAjax.traiterErreurs($('#voies-publiques'), xhr, errorThrown);
                // erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', xhr, errorThrown);
                infos.ajouterMessageToast({
                    message: 'Erreur de sauvegarde',
                    messageCouleur: 'red'
                });
                wait.stop();
            });

    }

    function supprimerMunicipalite() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/supprimer-municipalite/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    // # 9311, ET
    function creerRoleXml() {
        var idMunicipalite = $('#adm-liste-ville').val();
        // var idMunicipalite = $('#adm-numero-municipalite').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/creer-xml-role/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function postImportation() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/post-importation/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function importerDocument() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/importer-document/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function importerSelectionnes(motifPrive) {
        wait.start();
        // désactive les boutons d'import !
        $('#content-importation-xml :button ').attr('disabled', 'disabled')
        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        if (motifPrive) {
            params.bool_motif_prive = motifPrive;
        }

        var listeFichier = [];

        $('#content-importation-xml input[name="adm-doc-1"]:checked').each(function () {
            listeFichier.push($(this).val().trim());
        });

        params.liste_fichier = JSON.stringify(listeFichier);

        if($('#bool_reprise_auto').is(":checked")) {
            params.bool_reprise_auto = true;
        }else if($('#reprise_id').val()){
            params.reprise_id = $('#reprise_id').val();
        }


        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/importer-selectionnes/",
            data: params,
            dataType: 'json',
            success: function (response) {
                infos.ajouterMessageToast({
                        message: 'Import lancé.',
                        messageDuree: 500,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green'
                });
                wait.stop();
            }
        });
    }

    function balancerSommaire() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        var listeFichier = [];

        $('#content-importation-xml input[name="adm-doc-1"]:checked').each(function () {
            listeFichier.push($(this).val().trim());
        });

        params.liste_fichier = JSON.stringify(listeFichier);

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/balancer-sommaire/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function importerTotal() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/importer-total/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function importerCustom(importAction) {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        var listeFichier = [];

        $('#content-importation-xml input[name="adm-doc-1"]:checked').each(function () {
            listeFichier.push($(this).val().trim());
        });

        params.liste_fichier = JSON.stringify(listeFichier);
        params.import_action = importAction;

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/importer-custom/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function finContratExportation() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/exportation/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();
            }
        });
    }

    function importerEnquetesVentesAdHoc() {
        wait.start();

        var idMunicipalite = $('#adm-liste-ville').val();

        var params = {
            "id_municipalite": idMunicipalite
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/importer-enquetes-vente-ad-hoc/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();

                if (response) {
                    $('#enquete-vente-ad-hoc-reponse').html('');
                    var html = '';
                    $.each(response, function(index) {
                        html += '<span>';
                        $.each(response[index], function (key, value) {
                            html += key + ' = ' + value + ', ';
                        });
                        html += '</span></br>';
                    });
                    $('#enquete-vente-ad-hoc-reponse').html(html);
                }
            }
        });
    }

    return {
        sauvegarderVoiePublique: sauvegarderVoiePublique,
        sauvegarderExtrantMunicipalite:sauvegarderExtrantMunicipalite,
        sauvegarderUniteVoisinage: sauvegarderUniteVoisinage,
        sauvegarderZonage: sauvegarderZonage,
        creerRoleEvaluation: creerRoleEvaluation,
        creerEditerVoiePublique: creerEditerVoiePublique,
        uniteVoisinageFicheDescriptive: uniteVoisinageFicheDescriptive,
        creerEditerUniteVoisinage: creerEditerUniteVoisinage,
        creerEditerZonage: creerEditerZonage,
        importerDataTableTablePilotage: importerDataTableTablePilotage,
        importerDataTableTableExtrant: importerDataTableTableExtrant,
        initSuppressionExtrantMunicipalite: initSuppressionExtrantMunicipalite,
        ajouterExtrantMunicipalite:ajouterExtrantMunicipalite,
        importerDataTableTableVoisinage: importerDataTableTableVoisinage,
        supprimerMunicipalite: supprimerMunicipalite,
        postImportation: postImportation,
        importerDocument: importerDocument,
        importerSelectionnes: importerSelectionnes,
        balancerSommaire: balancerSommaire,
        importerTotal: importerTotal,
        importerCustom: importerCustom,
        creerRoleXml: creerRoleXml,
        finContratExportation: finContratExportation,
        importerEnquetesVentesAdHoc: importerEnquetesVentesAdHoc,
    };
})
(); // namespace evaluationAdministration

// pour l'onglet pilotage de la municipalité.
// des que l'on lance le chargement de l'onglet on set à true;
var content_pilotage_municipalite_loading = false;

function admGetMunicipalite(idMunicipalite) {
    wait.start();

    let params = {
        "id_municipalite": idMunicipalite,
        "id_module": $("#sidebar li.active ul.submenu li.active a").attr('id_module')
    };
    let success_cb = function (response) {
        $('#content-historique-role').html(response.html_historique_role);
        $('#content-gestion-regroupement').html(response.html_gestion_regroupement);
        $('#content-extrant').html(response.html_extrant);
        $('#content-pilotage-municipalite').html(response.html_pilotage);
        $('#content-voie-publique').html(response.html_voie_publique);
        $('#content-importation-xml').html(response.html_importation_xml);
        $('#content-exportation').html(response.html_exportation);
        $('#content-onglet-zonage').html(response.html_zonage);
        $('.tabbable').find('li').each(function () {
            $(this).removeAttr('charge');
        });
        $('.tabbable').find('li.active').each(function () {
            chargerOngletAdministration($(this));
        });
        $('#form-ouvrir-role-preparation').on('submit', function (e) {
            e.preventDefault();
            $('#form-ouvrir-role-preparation').find('button[type="submit"]').attr('disabled', 'disabled');
            wait.start();
            let url = $(this).attr('action');
            let method = $(this).attr('method');
            let data = $(this).serialize();
            let success_cb = function(rsp) {
                $('#modal-ouvrir-role-preparation').modal('hide');
                wait.stop();
                $('#form-ouvrir-role-preparation').find('button[type="submit"]').removeAttr('disabled');
                infos.ajouterMessageToast({
                    message: rsp.msg,
                    messageDuree: 1500,
                    icone: 'fa-check-circle-o',
                    messageCouleur: "green"
                });
                $('#adm-liste-ville').trigger('change');
            };
            call_ajax(url, method, data, success_cb);
        });
    };
    call_ajax("/gestion-roles/administration-evaluation/municipalite/", "POST", params, success_cb);
}
var pilotage_municipalite_url;
var pilotage_municipalite_elem;
function admGetContentPilotageMunicipalite(idMunicipalite){
    wait.start();
    pilotage_municipalite_url = "/gestion-roles/administration-evaluation/municipalite/" + idMunicipalite + "/pilotage-municipalite/";
    pilotage_municipalite_elem = $("#content-pilotage-municipalite");

    $.ajax({
        type: "GET",
        url: pilotage_municipalite_url,
        dataType: 'html',
        success: function (response) {
            let resp = JSON.parse(response);
            $(pilotage_municipalite_elem).html(resp.template);
            initPilotageMunicipalite(idMunicipalite, resp.peut_edit_parametre_generaux_municipalite);
        }
    });
}
function initPilotageMunicipalite(idMunicipalite, peut_edit_parametre_generaux_municipalite){
    var options = {blocsContainer: pilotage_municipalite_elem};
    initBlocsCharges(null, null, options);

    $('#content-pilotage-municipalite form #form-bool_date_limite').on('change', (e) => {
        let checked = $(e.currentTarget).is(":checked");
        let bool_afficher_date_limite = $("#content-pilotage-municipalite form #form-bool_voir_verso_date_limite");
        if (checked && bool_afficher_date_limite.is(':checked')) bool_afficher_date_limite.click();
        bool_afficher_date_limite.attr("disabled", checked);
        bool_afficher_date_limite.parent().attr("disabled", checked);
    });

    $('#content-pilotage-municipalite form #form-bool_saisir_date_expedition_avis_modification').on('change', (e) => {
        let checked = $(e.currentTarget).is(":checked");
        let bool_cocher_date_limite = $("#content-pilotage-municipalite form #form-bool_date_limite");
        if (checked && !bool_cocher_date_limite.is(':checked')) bool_cocher_date_limite.click();
        bool_cocher_date_limite.attr("disabled", checked);
        bool_cocher_date_limite.parent().attr("disabled", checked);
    });

    if (peut_edit_parametre_generaux_municipalite){
        let submit_button_pilotage_municipalite = '<button class="btn btn-sm btn-info" id="enregistrer-pilotage-municipalite" title="Sauvegarder"><i class="ace-icon fa fa-hdd-o"></i> Sauvegarder</button>';
        $('#content-pilotage-municipalite form').append(submit_button_pilotage_municipalite);
    }

    $('.phone').mask('(999) 999-9999');
    $('#enregistrer-pilotage-municipalite').on("click", function(e){
         e.preventDefault();
         let options = {
            modeSave: ModeSave.MENU,
            blocsContainer: pilotage_municipalite_elem,
            id_municipalite: idMunicipalite,
            paramsSupp: {
                sauvegarde_complet: true,
                id_municipalite: idMunicipalite,
            }

        };
        var callback_sauvegarder_pilotage_municipalite = function (response) {
            if (response.reponse == 'ok') {
                if (response.avertissements == undefined) {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie',
                        messageDuree: 500,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green'
                    });
                } else {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                        messageDuree: 0,
                        icone: 'fa-exclamation-triangle',
                        iconeCouleur: 'orange'
                    });
                }
                // Lors d'un enregistrement avec succès, on recharge le formulaire
                admGetContentPilotageMunicipalite(idMunicipalite);
            } else {
                    infos.ajouterMessageToast({
                        message: "Erreur de sauvegarde : une valeur requise est manquante",
                        messageCouleur: "red",
                        messageDuree: 0,
                        type: 'error'
                    });
                }
        };
        saveBlocs(false, callback_sauvegarder_pilotage_municipalite, options);
    });
    wait.stop();
}



function tableHistoriqueRole(idMunicipalite) {

    var table = $('#adm-table-historique-role');
    table.find('tbody').remove();
    table = initTableDatatable(table, {
        processing: false,
        scrollX: true,
        searching: false,
        aaSorting: [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        bFilter: false,
        bInfo: false,
        stateSave: false,
        bLengthChange: false,
        pageLength: 3,
        ajax: {
            "url": `/gestion-roles/administration-evaluation/json-historique-role/municipalite/${idMunicipalite}/origine/1/`,
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
            }
        },
        columns: [
            {"data": "annee_debut", "title": "Année de début"},
            {"data": "annee_fin", "title": "Année de fin"},
            {"data": "date_depot_prevue", "title": "Date de dépôt prévue"},
            {"data": "date_depot", "title": "Date de dépôt officielle"},
            {"data": "date_depot_reelle", "title": "Date de dépôt réelle"}
        ],
    });
    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
    table.on('click', 'tr', function () {
        if (!$(this).hasClass('selected')) {
            table.$('tr.selected').removeClass('selected');

            $(this).addClass('selected');

            var id = $(this).attr('id');
            var value = id.substring(5);
            $('#current-role').val(value);
            $('#current-role-annee').val(table.row($(this).index()).data()['annee_debut']);
            admGetInfoRole(value);
        }
    });
}

function admGetInfoRole(idRole) {

    wait.start();

    $.ajax({
        type: "GET",
        url: `/gestion-roles/administration-evaluation/info-role/${idRole}`,
        dataType: 'html',
        success: function (response) {
            wait.stop();

            $('#adm-role-courant').html(response);

            tableHistoriqueCycle(idRole);

            $('a[href=#content-proportion-mediane]').on('click', function (e) {
                setTimeout(function() {
                    if (!$.fn.DataTable.isDataTable('#adm-table-proportion-mediane')) {
                        tableProportionMediane(idRole);
                    }
                }, 100);
            });

            $('a[href=#content-depot-role]').on('click', function (e) {
                setTimeout(function() {
                    if (!$.fn.DataTable.isDataTable('#adm-table-depot-role')) {
                        tableDepotRole(idRole);
                    }
                     else {
                        refreshDatatables();
                    }
                }, 100);
            });

            $('a[href=#content-unite-voisinage]').on('click', function (e) {
                setTimeout(function() {
                    evaluationAdministration.importerDataTableTableVoisinage(idRole);
                }, 100);
            });


            $('#adm-btn-calcul-cout').on('click', function (e) {
                fenetreModal.modalMessage({
                    titre: "Ceci calculera toutes les unités du rôle courant. Continuer?",
                    texteExplicatif: "",
                    conteneur: "#editeur-modal-container",
                    taille: "grande",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                wait.start();

                                var idRole = $('#current-role').val();

                                var params = {
                                    "id_role": idRole
                                };

                                $.ajax({
                                    type: "POST",
                                    url: "/gestion-roles/administration-evaluation/calcul-cout/",
                                    data: params,
                                    dataType: 'json',
                                    success: function (response) {
                                        infos.ajouterMessageToast({
                                            message: 'Un courriel vous sera envoyé lorsque le calcul sera complété.',
                                            messageDuree: 0
                                        });
                                        wait.stop();
                                    }
                                });
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });
            });

            $('#adm-btn-porter-role').on('click', function (e) {
                fenetreModal.modalMessage({
                    titre: "Ceci portera au rôle toutes les unités du rôle courant. Continuer?",
                    texteExplicatif: "",
                    conteneur: "#editeur-modal-container",
                    taille: "grande",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                wait.start();

                                var idRole = $('#current-role').val();

                                var params = {
                                    "id_role": idRole
                                };

                                $.ajax({
                                    type: "POST",
                                    url: "/gestion-roles/administration-evaluation/porter-role/",
                                    data: params,
                                    dataType: 'json',
                                    success: function (response) {
                                        infos.ajouterMessageToast({
                                            message: 'Un courriel vous sera envoyé lorsque la tâche sera complétée.',
                                            messageDuree: 0
                                        });

                                        wait.stop();
                                    }
                                });
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });
            });

            // accordéon "Pilotage rôle" (Paramètres généraux)
            var options = {blocsContainer: $('#accordion-accordeon-parametres-generaux .panel-body')};
            initBlocsCharges(null, null, options);

            $('#content-parametre-role .panel-collapse').on('show.bs.collapse', function () {
                if ($(this).closest('#accordion-accordeon-parametres-generaux').length == 0) {
                    var table = $(this).find('.panel-body table');
                    tableParametreBase(table);

                    $('[name=btn-creer-bareme-role]').on('click', function (e2) {
                        editer_parametre_base(e2, null, this);
                    });
                    $('[name=btn-importer-bareme-role]').on('click', function (e2) {
                        importer_bareme_modale(e2, this);
                    });
                }
            });

            ouvrir_parametre_methode_cout();

            ouvrir_parametre_methode_revenu();

            ouvrir_parametre_methode_comparaison();


            $('a[href=#content-parametre-terrain]').on('click', function (e) {
                setTimeout(function() {
                    var table = $('#content-parametre-terrain').find('[name=table_parametre_terrain]');
                    if (!$.fn.DataTable.isDataTable(table)) {
                        tableParametreTerrain(table);

                        $('[name=btn-creer-bareme-terrain]').on('click', function (e2) {
                            editer_parametre_terrain(e2, null, this);
                        });
                    }
                }, 100);
            });

        }
    });
}

function ouvrir_parametre_methode_cout() {
    $('#content-parametre-cout .panel-collapse').on('show.bs.collapse', function () {
            var table = $(this).find('.panel-body table');
            tableParametreBase(table);
            $('[name=btn-creer-bareme-role]').on('click', function (e2) {
                editer_parametre_base(e2, null, this);
            });
            $('[name=btn-importer-bareme-role]').on('click', function (e2) {
                importer_bareme_modale(e2,  this);
            });
    });
}

function ouvrir_parametre_methode_comparaison() {
    $('#content-parametre-comparaison .panel-collapse').on('show.bs.collapse', function () {
        var table = $(this).find('.panel-body table');
        tableParametreBaremeComparaison(table);
        $('[name=btn-creer-bareme-methode-comparaison]').on('click', function (e2) {
            editer_parametre_base_methode_comparaison(e2, null, this);
        });
    });
}

function tableHistoriqueCycle(idRole) {

    var table = $('#adm-table-historique-cycle');
    table.find('tbody').remove();

    initTableDatatable(table, {
        'processing': false,
        "scrollX": true,
        "searching": true,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/json-historique-cycle/role/" + idRole + "/origine/1/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS

                wait.stop();
            }
        },

        "columns": [

            {"data": "nom", "title": "Nom"},
            {"data": "date_debut", "title": "Date de début"},
            {"data": "date_fin", "title": "Date de fin"},
            {"data": "actions", "title": "Actions"},
        ],

        "drawCallback": function () {

            table.find('.cycle-extrant').off('click').on('click', function (e) {
                $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL

                $('#modal-message-background').remove();

                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);

                $('#modal-document-cycle').val(idCycle1);


                $('#modal-document-titre').text('Cycle : ' + $(this).closest('tr').children('td:eq(0)').text());

                var date_fin = $(this).closest('tr').children('td:eq(2)').text();

                $('#adm-body-fichier-cycle').empty();
                $('#adm-body-fichier-cycle-creer').empty();

                if (idCycle1) {
                    var estSuperAdmin = ($('[name=hid-super-admin]').val() == '1');

                    if (date_fin || estSuperAdmin) {
                        admGetFichierCycle(idCycle1, 'adm-body-fichier-cycle', 1);
                    }
                    if (!date_fin || estSuperAdmin) {
                        admGetCreerFichierCycle(idCycle1, 'adm-body-fichier-cycle-creer', 37);
                    }

                    var btnGenerer = $('#btn-generer-modal-document');
                    btnGenerer.toggle((!date_fin || estSuperAdmin));

                    fenetreModal.calculerHauteurModal($('.contenu-principal'));
                } else {
                    $('#adm-body-fichier-cycle').html('').append(getBanniereMessage('', "Sélectionner un cycle"));
                }

                $('#modal-document').modal({
                    show: true,
                    backdrop: 'static'
                });

                masquesSelection.init();

                $('#modal-document-select-all-1').change(function () {
                    if ($(this).is(":checked")) {
                        $(':checkbox:not(.disabled)').prop('checked', true);
                    } else {
                        $(':checkbox:not(.disabled)').prop('checked', false);
                    }
                });

                // DM 2019-02-07: ajouté de bout rapidement car le "sélectionner tout" ne fonctionnait pas pour un cycle fermé (issue #7532)
                $('#modal-document-select-all-2').change(function () {
                    if ($(this).is(":checked")) {
                        $('.input-lg-2:not(.disabled)').prop('checked', true);
                    } else {
                        $('.input-lg-2:not(.disabled)').prop('checked', false);
                    }
                });

            });

            table.find('.cycle-fermer').not('.deuxieme-triennal').off('click').on('click', function (e) {
                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);

                var params = {idCycle1: idCycle1};

                var idEvenement = $(this).attr("data-id_evenement");

                tenueAJourModal.ouvrirWizardEvenement(idEvenement, params);
            }); // fin de table

            table.find('.cycle-statistique').off('click').on('click', function (e) {

                $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
                $('#modal-message-background').remove();

                //var idCycle = $('#current-cycle').val();
                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);

                $('#adm-body-stats-cycle').empty();


                if (idCycle1) {
                    admGetStatsCycle(idCycle1);
                } else {
                    $('#adm-body-stats-cycle').html('').append(getBanniereMessage('', "Sélectionner un cycle"));
                }


                $('#modal-stats').modal({
                    show: true,
                    backdrop: 'static'
                });

            }); // fin de tables


            table.find('.cycle-reouverture').off('click').on('click', function (e) {

                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);

                fenetreModal.modalMessage({
                    titre: "Êtes-vous certain de vouloir réouvrir le cycle (le cycle en cours sera supprimé), êtes-vous certain ?",
                    sansX: true,
                    texteExplicatif: "",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                var params = {
                                    "id_cycle_1": idCycle1
                                };

                                $.ajax({
                                    type: "GET",
                                    url: "/gestion-roles/administration-evaluation/reouverture-cycle/",
                                    data: params,
                                    dataType: 'json',
                                    success: function (response) {
                                        wait.stop();
                                        infos.ajouterMessageToast({
                                            message: 'Votre cycle est à nouveau ouvert.',
                                            messageDuree: 1500
                                        });
                                        refreshDatatables();

                                    }
                                });

                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {

                            }
                        }
                    }
                });


            });

             table.find('.cycle-facturation').off('click').on('click', function (e) {

                $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
                $('#modal-message-background').remove();

                //var idCycle = $('#current-cycle').val();
                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);
                $('#modal-facturation-titre').text('Facturation Cycle : ' + $(this).closest('tr').children('td:eq(0)').text());
                $('#adm-body-facturation-cycle').empty();
                 var idRole = $('#current-role').val();
                if (idCycle1) {
                    admGetFacturationCycle(idCycle1,idRole);

                } else {
                    $('#adm-body-facturation-cycle').html('').append(getBanniereMessage('', "Sélectionner un cycle"));
                }
                $('#modal-facturation').modal({
                    show: true,
                    backdrop: 'static'
                });
            }); // fin de tables
            table.find('.cycle-facturation-inspection').off('click').on('click', function (e) {

                $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
                $('#modal-message-background').remove();

                //var idCycle = $('#current-cycle').val();
                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);
                $('#modal-facturation-inspection-titre').text('Facturation Cycle : ' + $(this).closest('tr').children('td:eq(0)').text());
                $('#adm-body-facturation-inspection').empty();
                 var idRole = $('#current-role').val();
                if (idCycle1) {
                        var url = $(this).attr('url');
                    admGetFacturationInspection(url, idCycle1,idRole);
                    $('#modal-facturation-inspection-cycle').find('[name=btn-generer-rapport-facturation]').off('click').on('click', function () {
                        genererRapportInspection(idCycle1, idRole);
                    });
                    fermerCycleFacturation($('#modal-facturation-inspection-cycle'), idCycle1,idRole);
                } else {
                    $('#adm-body-facturation-inspection').html('').append(getBanniereMessage('', "Sélectionner un cycle"));
                }
                $('#modal-facturation-inspection-cycle').modal({
                    show: true,
                    backdrop: 'static'
                });
            });

            table.find('.cycle-facturation-inspection-rapport').off('click').on('click', function (e) {
                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);
                 var idRole = $('#current-role').val();
                if (idCycle1) {
                    genererRapportInspection(idCycle1, idRole);
                }
            });
            table.find('.cycle-facturation-inspection-rouvrir').off('click').on('click', function (e) {
                var id = $(this).closest('tr').attr('id');
                var idCycle1 = id.substring(6);
                 var idRole = $('#current-role').val();
                if (idCycle1) {
                    rouvrirCycleFacturation(idCycle1,idRole);
                }
            }); // fin de tables




        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });

    $('#btn-generer-modal-document').off('click').on('click', function (e) {
        wait.start();

        var listeContainer = [{element: $("#modal-document")}];
        var params = admGetGenererDocumentParams(listeContainer, true);

        $.ajax({
            type: "GET",
            url: "/gestion-roles/administration-evaluation/generer-document/",
            data: params,
            dataType: 'json',
            success: function (response) {
                wait.stop();

                infos.ajouterMessageToast({
                    message: 'Un courriel vous sera envoyé lorsque vos documents auront été générés.',
                    messageDuree: 0
                });
            }
        });
    });
}

function admGetGenererDocumentParams(listeContainer, isIndividuel) {
    var retour = [];

    $.each(listeContainer, function (idx, item) {
        var containerElement = item.element;

        var params = containerElement.find(":input").serializeArray();
        params.push({name: 'is_individuel', value: isIndividuel});

        var idCycle = item.idCycle;
        if (idCycle) {
            params.push({name: 'id_cycle', value: idCycle});
        }

        retour.push(params);
    });

    return [{name: 'donnees', value: JSON.stringify(retour)}];
}


function admGetCreerFichierCycle(idCycle, fenModalBody, typeEvenement) {

    $('#' + fenModalBody).html('');
    var params = {
        "id_cycle": idCycle,
        "id_type_evenement": typeEvenement
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/administration-evaluation/creer-fichier-cycle/",
        data: params,
        dataType: 'html',
        async: false,
        success: function (response) {
            $('#' + fenModalBody).html(response);
        }
    });
}

function admGetStatsCycle(idCycle) {

    var params = {
        "id_cycle": idCycle
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/administration-evaluation/stats-cycle/",
        data: params,
        dataType: 'html',
        async: false,
        success: function (response) {
            $('#adm-body-stats-cycle').html(response);
        }
    });
}
function admGetFacturationCycle(idCycle,idRole) {

    var params = {
        "id_cycle": idCycle,
        'id_role_evaluation':idRole
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/administration-evaluation/facturation-cycle/",
        data: params,
        dataType: 'html',
        async: false,
        success: function (response) {
            $('#adm-body-facturation-cycle').html(response);
             tableGestionFacturationCycle(idCycle,idRole);
        }
    });
}

function genererRapportInspection(idCycle, idRole)
    {
        var params = {
        "id_cycle": idCycle,
        'id_role_evaluation': idRole};

                wait.start('contenu');
                setTimeout(function () {

                    //on genere xml et affiche si erreur
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/administration-evaluation/generer-rapport-facturation-inspection/",
                        async: false,
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop('contenu');

                            if (response.erreur) {
                                infos.ajouterMessageToast({
                                    message: "Erreur: " + response.erreur,
                                    messageDuree: 0
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: "Vous recevrez le rapport de facturation des inspectons sous peu...",
                                    messageDuree: 0
                                });
                                $('#modal-facturation-inspection-cycle').modal('hide');
                                refreshDatatables();
                            }
                        }
                    });

                }, 0);

    }
    function fermerCycleFacturation(pageCourante, idCycle, idRole)
    {
        var params = {
        "id_cycle": idCycle,
        'id_role_evaluation': idRole};
         var btnExporterpdf = pageCourante.find('[name=btn-fermer-cycle-facturation]');
            btnExporterpdf.off('click').on('click', function () {
                wait.start('contenu');

                setTimeout(function () {

                    //on genere xml et affiche si erreur
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/administration-evaluation/fermer-cycle-facturation/",
                        async: false,
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            btnExporterpdf.prop('disabled', false);

                            if (response.erreur) {
                                infos.ajouterMessageToast({
                                    message: "Erreur: " + response.erreur,
                                    messageDuree: 0
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: "Cycle de facturation fermé avec succes",
                                    messageDuree: 500,
                                    icone: 'fa-check-circle-o',
                                    iconeCouleur: 'green'
                                });
                              $('#modal-facturation-inspection-cycle').modal('hide');
                              refreshDatatables();
                            }
                                                        wait.stop('contenu');

                        }
                    });

                }, 0);
            });

    }
    function rouvrirCycleFacturation(idCycle, idRole)
    {
        var params = {
        "id_cycle": idCycle,
        'id_role_evaluation': idRole};
                wait.start('contenu');
                setTimeout(function () {

                    //on genere xml et affiche si erreur
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/administration-evaluation/rouvrir-cycle-facturation/",
                        async: false,
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            if (response.erreur) {
                                infos.ajouterMessageToast({
                                    message: "Erreur: " + response.erreur,
                                    messageDuree: 0
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: "Cycle reouvert avec succes",
                                    messageDuree: 500,
                                    icone: 'fa-check-circle-o',
                                    iconeCouleur: 'green'
                                });
                                   refreshDatatables();

                            }
                           wait.stop('contenu');

                        }
                    });

                }, 0);

    }
function admGetFacturationInspection(url, idCycle,idRole) {
    wait.start();
    var params = {
        "id_cycle": idCycle,
        'id_role_evaluation': idRole
    };
    // Récupérez les données du formulaire
    $.ajax({
            type: "GET",
            url: url,
        data:params,
            success: function (response) {
                 $('#adm-body-facturation-inspection').html(response);
                     var table = $('#adm-table-facturation-inspection');
                   initTableDatatable(table,{});
                                    wait.stop();

                }
            });

}

function tablefacturationinspection(url)
{
    var table = $('#adm-table-facturation-inspection');

    initTableDatatable(table, {
        'paging': false,
        'processing': false,
        "scrollX": true,
        "searching": false,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": url,
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                wait.stop();
            }
        },

        "columns": [
            {"data": "nom_evenement", "title": "Événement"},
            {"data": "devis_liste", "title": "Liste des items"},
            {"data": "fichier", "title": "Date de Modification"},
            {"data": "actions", "title": "Actions"}
        ],

        "drawCallback": function () {


        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });

}

function admGetFacturationsParams(listeContainer, id_cyle) {
    var table = 'adm-table-facturation-cycle';

    var tableObject = $('#' + table + ' tbody tr').map(function () {
        var row = {};
        var id = $(this).attr('id');
        var idevenement = id.substring(4);
        var id_ue = $(this).attr("data-id_ue");
        var matricule_precedent = $(this).attr("data-matricule_precedent");
        var matricule_courant = $(this).attr("data-matricule_courant");
        var po_type_evenement_description = $(this).attr("data-po_type_evenement_description");
        var motif_avis= $(this).attr("data-motif_avis");
        var po_no_certificat= $(this).attr("data-po_no_certificat");
        var date_evenement=  $(this).attr("data-date_evenement");
        var variation_imposable_immeuble =  $(this).attr("data-variation_imposable_immeuble");
        var triennal =  $(this).attr("data-triennal");
        if(listeContainer.includes(idevenement)==true) {
            $(this).find('td').each(function () {
                              //select2 multiple
                if ($(this).attr('dataValue') == 'select') {
                    var list_baremes = $(this).find('[name="baremes"]').select2('data');
                    var listeBareme = [];
                    $.each(list_baremes, function (index, value) {
                        var element = value.element ;
                        var $element = $(element) ;
                        if($element.attr('data-etat')!='inactif')
                            listeBareme.push(value.id);
                    });
                    row['id_bareme_liste'] = listeBareme;
                    row['id_evenement'] = idevenement;
                    row['id_cycle'] = id_cyle;
                    row['variation_imposable_immeuble'] = variation_imposable_immeuble;
                }
            });
            return row;
         }
    }).get();

    return [{name: 'donnees', value: JSON.stringify(tableObject)}];

}
function tableGestionFacturationCycle(idCycle,idRole) {
                wait.start();
                var apercu = false;
                var paramsEvenementTouche = [];
                var paramsItemadd = [] ;
                var paramsItemdelete = [] ;
    var table = $('#adm-table-facturation-cycle');
    var btnsavebaremefacture =  $('#btn-sauvegarder-bareme-facturation-evenement');
    var btnrechargerbaremefacture = $('#btn-recharger-bareme-facturation-evenement');
    table.find('tbody').remove();
    initTableDatatable(table, {
        async: false, // Si True, les listes des filtres s'écrasent dans la dernière liste de sélection puisque la
        // génération des boutons arrive après la fin de l'exécution ajax.
        order: [[1, 'asc']],
        "paging":   false,
        "processing": false,
        "scrollX": true,
        "pageLength": 25,
        "scrollY": "400px",
        "scrollCollapse": true,
        responsive: false,
        searching: true,
        ajax: {
            "url": "/gestion-roles/administration-evaluation/json-facturation-cycle/cycle/" + idCycle + "/role/" + idRole +"/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
            }
        },

        columns: [
            {data: "po_triennal",name: "po_triennal", title: "Triennal",targets:0,className: "dt-center"},
            {data: "id_ue",name: "id_ue", title: "Unité d'évaluation",targets:1,className: "dt-center"},
            {data: "matricule_precedent",name: "matricule_precedent", title: "Matricule précédent",targets:2,className: "dt-center"},
            {data: "matricule_courant",name: "matricule_courant", title: "Matricule courant",targets:3,className: "dt-center"},
            {data: "po_type_evenement_description", title: "Évènement ",targets:4,className: "dt-center"},
            {data: "date_evenement", title: "Date évènement",targets:5,className: "dt-center"},
            {data: "motif_avis", title: "Motif",targets:6,className: "dt-center"},
            {data: "po_no_certificat", title: "No. certificat",targets:7,className: "dt-center"},
            {data: "variation_imposable_immeuble", title: "Variation valeur ",targets:8,className: "dt-center"},
            {
                data: "baremes_evenement",name : "item-facturation", targets:9,className: "dt-center",title: "Items de Facturations",
                render: function (data, type, row) {
                    wait.stop();
                    var ddl = "<div class='form-group'>";
                    ddl += "<div id ='bareme-facturation2' class='select2-container select2-container-multi geo-select form-control controle-modifie portrait_anterieur'></div>";
                    ddl += "<select name='baremes' id ='bareme-facturation' multiple tabindex='-1' initial-value='"+data+"' initial-choices='"+data+"' class='geo-select form-control geo-select-ajax  cascade-combobox'>";
                    ddl += "<div class='select2-search'><option></option></div>";
                    var liste = data;

                    for (var i in liste) {
                        ddl += "<option value="+liste[i]['id']+" selected "+ " style='font-size:11px;font-weight:bold;'>";
                        if(liste[i]['bool_retenu']===true && liste[i]['bool_propose'] === false) {
                            var paritem = { value:liste[i]['id'],idEvenement: liste[i]['idEvenement'],bool_retenu:liste[i]['bool_retenu'],bool_propose:liste[i]['bool_propose']};
                            paramsItemadd.push(paritem);
                        }
                        if(liste[i]['bool_retenu']===false) {
                            var paritem2 = { value:liste[i]['id'],idEvenement: liste[i]['idEvenement'],bool_retenu:liste[i]['bool_retenu'],bool_propose:liste[i]['bool_propose']};
                            paramsItemdelete.push(paritem2);
                        }

                        ddl += liste[i]['description'] +"</option>";
                    }
                    ddl += "</select>";
                    ddl +="<div class='space-6'></div></div>";
                    return ddl;
                },
            }
        ],
        "columnDefs": [
            {"width": "10%", "targets": 0},
            {"width": "5%", "targets": 1},
            {"width": "12%", "targets": 2},
            {"width": "12%", "targets": 3},
            {"width": "10%", "targets": 4},
            {"width": "5%", "targets": 5},
            {"width": "23%", "targets": 6},
            {"width": "5%", "targets": 7},
            {"width": "5%", "targets": 8},
            {"width": "25%", "targets": 9},
        ],
        createdRow: function( row, data) {
            $(row).find('th:eq(8)').attr('name','baremes');
            $(row).find('td:eq(8)').attr('dataValue','select');
            $(row).attr("data-id_ue", data.id_ue);
            $(row).attr("data-matricule_precedent", data.matricule_precedent);
            $(row).attr("data-matricule_courant", data.matricule_courant);
            $(row).attr("data-po_type_evenement_description", data.po_type_evenement_description);
            $(row).attr("data-motif_avis", data.motif_avis);
            $(row).attr("data-po_no_certificat", data.po_no_certificat);
            $(row).attr("data-date_evenement", data.date_evenement);
            $(row).attr("data-variation_imposable_immeuble", data.variation_imposable_immeuble);
            $(row).attr("data-id_baremes",JSON.stringify(data.all_baremes_role));
            $(row).attr("data-triennal", data.po_triennal);
        },
        drawCallback: function () {
            $('[name="baremes"]').select2({
                formatSelection: function (data, container) {
                    var etat, colors;
                    var idinit  = $(data.element).parent().parent().parent().parent().attr('id');
                    var idevenementinit = idinit.substring(4);
                    var dataresultadd = (paramsItemadd && paramsItemadd.find(function( ele ) {
                        return ele.value === data.id  && ele.idEvenement === idevenementinit  && ele.bool_retenu===true && ele.bool_propose===false;
                    } ));
                    var dataresultdel =(paramsItemdelete && paramsItemdelete.find( function( ele ) {
                        return ele.value === data.id  && ele.idEvenement === idevenementinit  && ele.bool_retenu===false;
                    }));

                    if((dataresultadd)||(dataresultdel)) {
                        etat = (dataresultadd) ? 'actif': 'inactif';
                        colors = (dataresultadd) ? 'addbareme': 'deletebareme';
                        $(data.element).attr('data-etat', etat);
                        return $('<span id='+colors+'>' + data.text + '</span>');
                    }
                    return data.text;
                },
            }).trigger('change');

            $('#adm-table-facturation-cycle tbody tr').each(function () {
                var baremes= $(this).attr('data-id_baremes');
                if (baremes !== undefined) {
                    var bar = JSON.parse(baremes);
                    for (var i in bar) {
                        if ($(this).find('td').find('[name="baremes"]').find("option[value='" + i + "']").length) {
                            $(this).val(i).trigger('change');
                        } else {
                            var newOption = new Option(bar[i], i, false, false);
                            $(this).find('td').find('[name="baremes"]').append(newOption).trigger('change');
                        }
                    }
                }
            });
            var disabled = true ? $('#adm-table-facturation-cycle').DataTable().data().count() <= 0 : false;
            btnrechargerbaremefacture.prop("disabled", false);
            $('[name="baremes"]').off('change').on('change', function (e) {
                var id  = $(this).parent().parent().parent().attr('id');
                var idevenement = id.substring(4);
                paramsEvenementTouche.indexOf(idevenement) === -1 ? paramsEvenementTouche.push(idevenement) : 0;
                btnsavebaremefacture.prop("disabled", disabled);
                if (e.removed) {
                    var item2 = e.removed;
                    var ltitem2 = { value:item2.id,idEvenement: idevenement,bool_retenu:false,bool_propose:true};
                    if ($(item2.element).attr('data-etat')!='actif') {
                        if ($(item2.element).attr('data-etat')=='inactif') {
                            for(var i = 0;i < paramsItemdelete.length; i ++) {
                                if(JSON.stringify(paramsItemdelete[i])==JSON.stringify(ltitem2)) {
                                    paramsItemdelete.splice(i, 1);
                                    i--;
                                }
                            }
                        }
                        else paramsItemdelete.push(ltitem2);
                        var newOption2 = new Option(item2.text, item2.id, false, true);
                        $(this).append(newOption2).trigger('change').select2();

                        $(this).select2({
                            formatSelection: function (data, container) {
                                var dataresult2 =paramsItemdelete.find( function( ele ) {
                                    return ele.value === data.id  && ele.idEvenement===idevenement;
                                });
                                if((dataresult2) && (($(data.element).attr('data-etat')===undefined)||($(data.element).attr('data-etat')==='inactif')))
                                {
                                    if ($(data.element).attr('data-etat')===undefined)
                                    $(data.element).attr('data-etat', 'inactif');
                                    return $('<span id="deletebareme">' + data.text + '</span>');
                                }
                                else {
                                    if ($(data.element).attr('data-etat')!==undefined)
                                    $(data.element).removeAttr('data-etat') ;
                                    var dataresultadd =paramsItemadd.find( function( ele ) {
                                        return ele.value === data.id  && ele.idEvenement===idevenement;
                                    } );
                                    if(dataresultadd) {
                                        $(data.element).attr('data-etat', 'actif');
                                        return $('<span id="addbareme">' + data.text + '</span>');
                                    }
                                    return data.text;
                                }
                            },
                        }).trigger('change');
                    }
                    else {
                        for(var j = 0;j < paramsItemadd.length; j ++) {
                            if(JSON.stringify(paramsItemadd[j])==JSON.stringify(ltitem2))
                            {
                                paramsItemadd.splice(i, 1);
                                j--;
                            }
                        }
                        $(item2.element).removeAttr('data-etat') ;
                    }
                }
                if (e.added) {
                    var item =e.added;
                    var ltitem = { value:item.id,idEvenement: idevenement,bool_retenu:true,bool_propose:false};
                    paramsItemadd.push(ltitem);
                    $(this).select2({
                        formatSelection: function (data, container) {
                            var dataresult =paramsItemadd.find( function( ele ) {
                                return ele.value === data.id  && ele.idEvenement===idevenement;
                            } );
                            if(dataresult) {
                                $(data.element).attr('data-etat', 'actif');
                                var $state = $(
                                    '<span id="addbareme">' + data.text + '</span>'
                                );
                                return $state;
                            }
                            else {
                                var dataresultadd =paramsItemdelete.find( function( ele ) {
                                    return ele.value === data.id  && ele.idEvenement===idevenement;
                                } );
                                if((dataresultadd)&&($(data.element).attr('data-etat')==='inactif')) {
                                    //$(data.element).attr('data-etat', 'inactif');
                                    return $(
                                        '<span id="deletebareme">' + data.text + '</span>'
                                    );
                                }
                                else
                                return data.text;
                            }
                        },
                    }).trigger('change');

                }

            });

        },
        initComplete: function(settings, json) {
            $('ul.nav-tabs li.active').removeClass('active');
            $('#btn-bareme-facturation-evenement').parent('li').addClass('active');
            wait.stop();
        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });

    $('#btn-recharge-modal-facturation').off('click').on('click', function () {
        refreshDatatables();
    });

    btnrechargerbaremefacture.off('click').on('click', function () {
        btnrechargerbaremefacture.prop('disabled', true);
        wait.start();
        var paramsfact = {
            "id_cycle": idCycle,
            'id_role_evaluation':idRole
        };
        $.ajax({
            type: "GET",
            url: "/gestion-roles/administration-evaluation/recharger-baremes/",
            data: paramsfact,
            dataType: 'json',
            success: function (response) {
                infos.ajouterMessageToast({
                    message: 'Un courriel vous sera envoyé lorsque la facturation sera complétée. SVP fermer l\'étape',
                    messageDuree: 0
                });
                wait.stop();
                btnsavebaremefacture.prop("disabled", true);
                $('#div-table-facturation-cycle *').attr("disabled",true);
                table.find('td').find('[name="baremes"]').attr("disabled", "disabled");
            }
        });
    });


    btnsavebaremefacture.off('click').on('click', function () {
        btnsavebaremefacture.prop('disabled', true);
        wait.start();
        var paramsfact = admGetFacturationsParams(paramsEvenementTouche, idCycle);

        $.ajax({
            type: "POST",
            url: "/gestion-roles/administration-evaluation/sauvegarder-baremes/",
            data: paramsfact,
            dataType: 'json',
            success: function (response) {
                wait.stop();
                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });
            }
        });
    });

    $('a[href=#content-btn-generer-facture-cycle]').on('click', function (e) {
        wait.start();
        var bar = 0 ;
        $('#adm-table-facturation-cycle tbody tr').each(function () {
            var baremes= $(this).attr('data-id_baremes');
            if (baremes !== undefined)
            {
                bar = JSON.parse(baremes);
            }
        });
        var params = {
            "id_cycle": idCycle,
            'id_role_evaluation':idRole
        };
        apercu=true;
        tableItemsFacturations(params, bar,apercu);
    });

    $('a[href=#content-btn-apercu-facturation-cycle]').on('click', function (e) {
        wait.start();
        var params = {
            "id_cycle": idCycle,
            'id_role_evaluation':idRole
        };
        var bar = 0 ;
        $('#adm-table-facturation-cycle tbody tr').each(function () {
            var baremes= $(this).attr('data-id_baremes');
            if (baremes !== undefined) {
                bar = JSON.parse(baremes);
            }
        });
        apercuFacturations(params, bar, apercu);
    });
}

function sortObjectByValueNumbers(data) {
    function splitKey(key) {
        // Divise la chaîne en segments numériques et non numériques
        return key.split(/(\d+)/).filter(Boolean).map(part => isNaN(part) ? part : parseInt(part, 10));
    }

    const sortedArray = Object.entries(data).sort((a, b) => {
        const aParts = splitKey(a[1].split(' ')[0]); // Prendre la partie numérique avant le premier espace
        const bParts = splitKey(b[1].split(' ')[0]); // Prendre la partie numérique avant le premier espace

        for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
            if (aParts[i] !== bParts[i]) {
                if (aParts[i] === undefined) return -1;
                if (bParts[i] === undefined) return 1;
                if (typeof aParts[i] === 'number' && typeof bParts[i] === 'number') {
                    return aParts[i] - bParts[i];
                }
                return aParts[i].localeCompare(bParts[i]);
            }
        }
        return 0;
    });

  return sortedArray; // retourne le tableau trié
}

function tableItemsFacturations(params, bar,apercu) {
    var columnsDef = [
            {data: "po_triennal",name: "po_triennal", title: "Triennal",targets:0,className: "dt-center"},
            {data: "date_evenement",name: "date_evenement", title: "Date de prise d'effet", targets:1},
            {data: "matricule_precedent",name: "matricule_precedent", title: "Matricule précédent", targets:2},
            {data: "matricule_courant",name: "matricule_courant", title: "Matricule courant", targets:3},
            {data: "description",name: "description", title: "Événement", targets:4},
            {data: "type_immeuble", name: "type_immeuble", title: "Type immeuble", targets:5},
            //{data: "code_utilisation",name: "code_utilisation", title: "Code Utilisation", targets:4},
            {data: "nature",name: "Nature", title: "Nature", targets:6},
            {data: "no_certificat",name: "no_certificat", title: "No certificat", targets:7},
            {data: "no_reference",name: "no_reference", title: "No référence", targets:8},
            {data: "variation_imposable_immeuble", title: "Variation valeur ",targets:9}
        ];
    var listeTargetsajuste =[10];
    var matargets = 10;
    bar = sortObjectByValueNumbers(bar);
    bar.forEach(function(value, index, array) {
        var descriptioncode = value[1];
        var i = value[0];
        var code = descriptioncode.substring(0,descriptioncode.indexOf(" "));
        var description = descriptioncode.substring(descriptioncode.indexOf(" ")+1,descriptioncode.length);
        var ltitem = { data:'item_'+i,name: 'item_'+description, title: code,targets:matargets};
        columnsDef.push(ltitem);
        matargets +=1;
        listeTargetsajuste.push(matargets);
    });
    var total = { data: "total", className: 'datatable-num-val-fact',name: "total", title: "Total",targets:matargets,width: "5%"};

    columnsDef.push(total);


     $.ajax({
        type: "POST",
        url: "/gestion-roles/administration-evaluation/facturation-cycle/",
        data: params,
        dataType: 'html',
        async: false,
        success: function (response) {
           $('#adm-body-facturation-cycle').html(response);
           var btnImprimer = $('#adm-body-facturation-cycle').find('[name=btn-tj-imprimer]');
           var btnImprimerexl = $('#adm-body-facturation-cycle').find('[name=btn-tj-exporter-excel]');
           var table = $('#adm-table-facture-cycle');
           var btnbareme =  $('#btn-bareme-facturation-evenement');
           var footer = $("<tfoot></tfoot>").appendTo("#adm-table-facture-cycle");
           var footertr = $("<tr></tr>").appendTo(footer);
           for (var i = 0; i < columnsDef.length; i++) {
               $("<td></td>").appendTo(footertr);
           }
           initTableDatatable(table, {
               async: false, // Si True, les listes des filtres s'écrasent dans la dernière liste de sélection puisque la
             // génération des boutons arrive après la fin de l'exécution ajax.
             order: [[1, 'asc']],
            "paging":   false,
            "processing": false,
            "scrollX": true,
            "pageLength": 25,
            "scrollY": "400px",
            "scrollCollapse": true,
            responsive: false,
            searching: true,
        ajax: {
            "url": "/gestion-roles/administration-evaluation/facturer-baremes/",
            "data": function (d) {
                d.columns = columnsDef; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                d.imprimer = false;
                d.id_role = params['id_role_evaluation'];
                d.id_cycle = params['id_cycle'];
            },
            type: "POST"

        },

        columns: columnsDef,
             "columnDefs": [
                 {"width": "8%", "targets": 0},
                 {"width": "5%", "targets": 1},
                 {"width": "8%", "targets": 2},
                 {"width": "9%", "targets": 3},
                 {"width": "5%", "targets": 4},
                 {"width": "5%", "targets": 5},
                 {"width": "25%", "targets": 6},
                 {"width": "5%", "targets": 7},
                 {"width": "5%", "targets": 8},
                 {"width": "7%", "targets": 9},
                 {
                      "render": function ( data, type, row ) {
                        // here you can convert data from base64 to hex and return it
                            var resultat = (data=='')?data:formatermontant(data);
                          return resultat;
                      },
                      "targets": listeTargetsajuste
                   },
                 {"className": "dt-center", "targets": "_all"}
                     ],
               createdRow: function( row, data){
                $(row).attr("data-matricule_precedent", data.matricule_precedent);
                $(row).attr("data-matricule_courant", data.matricule_courant);
                $(row).attr("data-description", data.description);
                $(row).attr("data-variation_imposable_immeuble", data.variation_imposable_immeuble);
                $(row).attr("data-total",data.total);
            },
               initComplete: function(settings, json) {
                                wait.stop();
                                                  var api = this.api();
        $('ul.nav-tabs li.active').removeClass('active');
        $('#btn-generer-facture-cycle').parent('li').addClass('active');
                var indice = 0 ;
                $('#adm-table-facture-cycle thead tr th').each(function () {
                    var $td = $(this);
                    var headerText = $td.text();
                    bar.forEach(function(value, index, array) {
                        var descriptioncode = value[1];
                        var code = descriptioncode.substring(0,descriptioncode.indexOf(" "));
                        var description = descriptioncode.substring(descriptioncode.indexOf(" ")+1,descriptioncode.length);
                        var sTitle = description;
                        if ( headerText == code ) {
                            var newText = code + "<span class='filterOptions' id='FilterStatus'>"+sTitle+"</span>";
                            $(api.column(indice).header()).html(newText);
                             $(api.column(indice).header()).attr("id", "hover");
                        }
                    });
                    indice +=1;
                });
                if (apercu===false) {
                    $('ul.nav-tabs li.active').removeClass('active');
                    $('#btn-apercu-facture-cycle').parent('li').addClass('active');
                }

        },

            footerCallback: function (row, data, start, end, display) {

                var indexTotal = -1;
                if (data.length > 0) {
                    //todo pour recuperer index autre maniere
                    var lestotaux = [] ;
                    indexTotal = this.api().columns()[0].length-1;
                    var valeurTot = 0 ;
                    var api = this.api();
		            for (let i=8 ; i<=indexTotal ; i++ ) {
                        api.columns(i).every(function() {
                            var sum = this.data().reduce(function(a, b) {
                                b = (b=='') ? 0 : ((i == indexTotal) ? b : 1);
                                var x = (i == indexTotal) ? parseFloat(a) : parseInt(a) ;
                                var y =  (i == indexTotal) ? parseFloat(b) : parseInt(b) ;
                                return x + y;
                              }, 0);
                            valeurTot = (i == indexTotal) ? sum.toFixed(2) : sum;
                            var cellFooter = $(api.column(i).footer());
                            var valeurTot1;
                            if (cellFooter.hasClass('datatable-num-val-2')) {
                                valeurTot1 = $.fn.dataTable.render.number(' ', '.', 2, '').display(valeurTot);
                            } else {
                                valeurTot1 = $.fn.dataTable.render.number(' ', '.', 0, '').display(valeurTot);
                            }
                            $( api.column(i).footer()).html(valeurTot1);
                            lestotaux.push(valeurTot);
                        });
                    }
                    var indexation = JSON.parse($('#adm-table-facture-cycle').attr('data-indexation'));
                    var newText = "Taux indexation pour "+indexation['annee']+" : "+indexation['taux_indexation']+" ; ";
                    var newtotal = parseFloat(indexation['taux_indexation'])*parseFloat(valeurTot) ;
                    var textTotal = "Total facture devient: " +formatermontant(newtotal.toFixed(2));
                    $('#footer-facturation').text(newText);
                    $('#footer-facturation-total').text(textTotal);
                    table.data('lestotaux', lestotaux);
                }
            },
               drawCallback: function () {
                var disabled = true ? $('#adm-table-facture-cycle').DataTable().data().count() <= 0 : false;
                       btnImprimerexl.prop("disabled", disabled);
                            btnImprimer.prop("disabled", disabled);
                             btnbareme.prop("disabled", disabled);
                             table.data('columnsDef', $.extend(true, {}, columnsDef));
                             table.data('id_role', params['id_role_evaluation']);
                            table.data('id_cycle', params['id_cycle']);
        }

    });
           $(table).on('processing.dt', function (e, settings, processing) {
               if (processing) {
                   wait.start();
               } else {
                   wait.stop();
               }
           });
           $('a[href=#content-btn-bareme-facturation-evenement]').on('click', function (e) {
               var cycle = params['id_cycle'] ;
               var role = params['id_role_evaluation'];
               admGetFacturationCycle(cycle ,role);
           });
           btnImprimerexl.off('click').on('click', function () {
               export_xls_taj_facturation(table,"/gestion-roles/administration-evaluation/export-xls-facturation/");
           });
           btnImprimer.off('click').on('click', function () {
               export_xls_taj_facturation(table,"/gestion-roles/administration-evaluation/export-pdf-facturation/");
           });
        }
    });
}

function apercuFacturations(params, bar,  apercu) {
    if(apercu===false)
         tableItemsFacturations(params, bar,apercu);
    else
        wait.stop();

$('ul.nav-tabs li.active').removeClass('active');
$('#btn-apercu-facture-cycle').parent('li').addClass('active');   //             }, 10000);

}
function formatermontant(dollars)
{
    const {format} = new Intl.NumberFormat('en-CA',
        {
            currency:'CAD',
            style:'currency',
            maximumFractionDigits: dollars % 1 ? 2 : 0
        });
    return format(dollars);

}
function export_xls_taj_facturation(tableElem, my_url) {
    var table = tableElem.DataTable();

    var unitesEvaluation = table.rows('.selected').data('id_evenement');
    var listeIdUe = [];
    $.each(unitesEvaluation, function (idx, value) {
        var idUe = value['matricule'];
        if (idUe != '') listeIdUe.push(idUe);
    });
    var colonnesDef = tableElem.data('columnsDef');
    var id_role = tableElem.data('id_role');
    var id_cycle = tableElem.data('id_cycle');
    var lestotaux = tableElem.data('lestotaux');

    var params = {
        order: table.order(),
        imprimer: true,
        lestotaux: JSON.stringify(lestotaux),
        listeIdUe: listeIdUe,
        id_role :id_role,
        id_cycle :id_cycle,
        colonnesDef: JSON.stringify(colonnesDef)
    };

    wait.start();

    $.ajax({
        type: "POST",
        url: my_url,
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'text',
        success: function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });

            wait.stop();
        } //end success
    }); //end ajax

}

function admGetFichierCycle(idCycle, fenModalBody, origine) {

    var params = {
        "id_cycle": idCycle
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/administration-evaluation/fichier-cycle/",
        data: params,
        dataType: 'html',
        async: false,
        success: function (response) {
            if (document.getElementById('doit_fermer_modal') && document.getElementById('doit_fermer_modal').value === 'True') {
                fenetreModal.fermerModal('modal-wizard-evenement');
                infos.ajouterMessageToast({
                                message: 'Le dépôt a été assigné au responsable de la signature.',
                                messageDuree: 5000,
                                messageCouleur: 'green'
                            });

            }
            $('#' + fenModalBody).html(response);
            tableFichierCycle(idCycle, fenModalBody, origine);
        }
    });

}


function tableFichierCycle(idCycle, fenModalBody, origine) {
    var table = $('#adm-table-fichier-cycle-1');
    if (origine == '3') {
        table = $('#' + fenModalBody);
    }

    table.find('tbody').remove();

    initTableDatatable(table, {
        'paging': false,
        'processing': false,
        "scrollX": true,
        "searching": false,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/json-fichier-cycle/cycle/" + idCycle + "/origine/" + origine + "/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS

                wait.stop();
            }
        },

        "columns": [
            {"data": "actions", "title": "Actions"},
            {"data": "type_document", "title": "Type de document"},
            {"data": "fichier", "title": "Fichier"}
        ],

        "drawCallback": function () {
            table.find('.telecharger-document').off('click').on('click', function (e) {
                var url = $(this).attr("url");
                window.open(url, '_blank');
            });

            table.find('.visualiser-erreur').off('click').on('click', function (e) {
                var idDocument = $(this).attr("data-id");
                tableErreurValidation(idDocument);

                $('#modal-erreur-validation').modal({
                    show: true,
                    backdrop: 'static'
                });
            });

            table.find('.editer-fichier-signature').on('change', function (e) {
                if (this.value) {
                    wait.start();
                    var docName = $(this).attr("data-name");
                    var formData = new FormData();
                    formData.append('fichier', this.files[0]);
                    formData.append('doc_name', docName);

                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/administration-evaluation/sauvegarder-fichier-signer-cycle/",
                        data: formData,
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            wait.stop();
                            infos.ajouterMessageToast({
                                message: 'Importation réussie',
                                messageDuree: 500,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });
                            $("#adm-table-fichier-cycle-1").dataTable().api().ajax.reload();
                            if ($("#adm-table-fichier-cycle-2")) {
                                $("#adm-table-fichier-cycle-2").dataTable().api().ajax.reload();
                            }
                        },
                        error: function (xhr, textStatus, error) {
                            wait.stop();
                            infos.ajouterMessageToast({
                                message: xhr.responseJSON['error'],
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'red',
                                messageDuree: 500
                            });
                        }
                    });
                }
            });


            var documents = table.find('.ace-file-input-signature');
            $.each(documents, function (idx, obj) {
                initAceInputFileSigner($(obj));
            });


        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
}


function initAceInputFileSigner(obj) {

    obj.ace_file_input({
        no_file: 'fichier ...',
        btn_choose: 'Choisir',
        btn_change: 'Changer',
        droppable: false,
        onchange: null,
        thumbnail: false, //| true | large
        whitelist: 'xml|txt'


    }).on('change', function () {
        initSaveInputFile($(this), '/gestion-roles/administration-evaluation/sauvegarder-signature-cycle/', function (response) {

            wait.stop();

            infos.ajouterMessageToast({
                message: 'Importation réussie',
                messageDuree: 500,
                icone: 'fa-check-circle-o',
                iconeCouleur: 'green'
            });
        }, function (response) {
            wait.stop();
        });
    });
}

function initSaveInputFile(my_input, my_url, callback, callback_error) {

    var idCycle1 = $('#wizard').attr('cycle-1');
    var submit_url = my_url;
    var deferred;
    var files = my_input.data('ace_input_files');

    if ("FormData" in window && !(typeof files === 'undefined' || files == null )) {
        var fd = new FormData();
        if (my_input.data('ace_input_method') == 'select') {
            if (files && files.length > 0) {
                fd.append(my_input.attr('name'), files[0]);
                fd.append('id_cycle_1', idCycle1);
                //to upload multiple files, the 'name' attribute should be something like this: myfile[]
            }
        }

        deferred = $.ajax({
            url: submit_url,
            type: "POST",
            processData: false,
            contentType: false,
            dataType: 'html',
            data: fd,

            success: function (response) {
                if (response != 'saved')
                    callback_error(response);
                else
                    callback(response);
            },

            error: function (xhr, textStatus, thrownError) {
                callback_error(thrownError + ': ' + textStatus);
            }
        });
        deferred.promise();
    }
    return false;
}


function tableErreurValidation(idDocument) {
    var table = $('#adm-table-erreur-validation');
    table.find('tbody').remove();

    table = initTableDatatable(table, {
        'destroy': true,
        'processing': false,
        "scrollX": true,
        "searching": true,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/json-erreur-validation/document/" + idDocument + "/origine/1/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS

                wait.stop();
            }
        },

        "columns": [{
            "data": "ligne",
            "title": "Ligne",
            "width": "60px"
        }, {
            "data": "colonne",
            "title": "Colonne",
            "width": "80px"
        }, {
            "data": "message",
            "title": "Message"
        }],

        "drawCallback": function () {
        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });

    table.on('click', 'tr', function () {

        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            table.$('tr.selected').removeClass('selected');

            $(this).addClass('selected');

            var id = $(this).attr('id');
            var value = id.substring(4);

            admGetInfoErreurValidation(value);
        }

    });
}


function admGetInfoErreurValidation(idErreur) {

    wait.start();

    var params = {
        "id_erreur": idErreur
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/administration-evaluation/info-erreur-validation/",
        data: params,
        dataType: 'html',
        success: function (response) {
            wait.stop();

            $('#adm-erreur-courante').html(response);
        }
    });
}


function tableFichierCycleXml(my_div, type, id, origine, callback) {
    var pageCourante = $('.step-pane.active');

    var table = $('.step-pane.active [name=' + my_div + ']');
    table.find('tbody').remove();

    initTableDatatable(table, {
        'paging': false,
        'processing': false,
        "scrollX": true,
        "searching": false,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "emptyTable": "Il n'y a pas d'erreur de validations",
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/json-fichier-cycle-xml/"+ type +"/" + id + "/origine/" + origine + "/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                wait.stop();
            }
        },

        "columns": [
            {"data": "actions", "title": "Statut"},
            {"data": "type_document", "title": "Type de document"}

        ],

        "drawCallback": function () {
            table.find('.telecharger-document').off('click').on('click', function (e) {
                var url = $(this).attr("url");
                window.open(url, '_blank');
            });

            table.find('.visualiser-erreur').off('click').on('click', function (e) {
                var idDocument = $(this).attr("data-id");
                tableErreurValidation(idDocument);

                $('#modal-erreur-validation').modal({
                    show: true,
                    backdrop: 'static'
                });
            });

            if (origine == 2) {
                var aDonnees = (pageCourante.find('.visualiser-erreur').length > 0);
                table.closest('[name="tableau-produire-extrant"]').toggle(aDonnees);
            }

            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));

        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
}

function admGetContentImportationXml(idMunicipalite) {
    function initInputFilesXml() {
        var inputFile = $('#content-importation-xml input[type=file]');

        inputFile.ace_file_input({
            style: 'well',
            btn_choose: 'Déposez un fichier ici ou cliquez pour en sélectionner un',
            btn_change: null,
            no_icon: 'ace-icon fa fa-cloud-upload',
            droppable: true,
            thumbnail: 'large'
        });

        inputFile.change(function () {
            wait.start();

            var idMunicipalite = $('#adm-liste-ville').val();
            var paramsSupp = {id_municipalite: idMunicipalite};

            init_save_input_file('frmEmployeurD', '/gestion-roles/administration-evaluation/upload_xml/', function (response) {
                wait.stop();

                infos.ajouterMessageToast({
                    message: 'Importation réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });

                setTimeout(function () {
                    initInputFilesXml();
                }, 100);

            }, function (response) {
                wait.stop();

                $('.form-employeur-d').html(response);

                setTimeout(function () {
                    initInputFilesXml();
                }, 100);
            }, true, paramsSupp);

        });
        $('[id=content-importation-xml] [name=chk-select-all]').change(function () {
            var checks = $('[id=content-importation-xml] table :checkbox:not([disabled])');

            if ($(this).is(":checked")) {
                checks.prop('checked', true).trigger('change');
            } else {
                checks.prop('checked', false).trigger('change');
            }
        });
        $('[id=content-importation-xml] .chk-select-batch').change(function () {
            let batch_checkbox = $(this);
            let liste_fichier = $(this).data('liste_fichier');
            liste_fichier = liste_fichier.split(',');
            $.each(liste_fichier, function (i, nom_fichier) {
                console.log(nom_fichier);
                if (nom_fichier === '') {
                    return true;
                }
                let checks = $('[id=content-importation-xml] table [value="' + nom_fichier + '"]');
                if ($(batch_checkbox).is(":checked")) {
                    checks.prop('checked', true).trigger('change');
                } else {
                    checks.prop('checked', false).trigger('change');
                }
            });
        });
        $('#table_import_xml input[type="checkbox"]').on('change', function(){
            $('#th_total_selected').text($('#table_import_xml input[type="checkbox"]:checked').length);
        });
        wait.stop();
    }

    wait.start();
    $.ajax({
        type: "GET",
        url: "/gestion-roles/administration-evaluation/municipalite/" + idMunicipalite + "/importation-xml/",  // TODO
        dataType: 'html',
        success: function (response) {
            let resp = JSON.parse(response);
            $("#content-importation-xml").html(resp.html);
            initInputFilesXml();
        }
    });
}


function tableProportionMediane(idRole) {

    var table = $('#adm-table-proportion-mediane');
    table.find('tbody').remove();
    initTableDatatable(table, {
        'processing': false,
        "scrollX": true,
        "searching": false,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/json-proportion-mediane/role/" + idRole + "/origine/1/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS

                wait.stop();
            }
        },

        "columns": [

            {"data": "annee_mediane", "title": "Année"},
            {"data": "actions", "title": "Actions"},
        ],

        "drawCallback": function () {

            table.find('.mediane-creation').off('click').on('click', function (e) {
                if ($(this).is('[disabled]')) {
                    return false;
                }

                //var idTypeEvenement = $(this).attr("data-id_type_evenement");
                //var idEvenement = $(this).attr("data-id_evenement");
                var idMunicipalite = $(this).attr("data-id_municipalite");
                //var idProcessus = $(this).attr("data-id_processus");
                //var idRoleEvaluation = idRole;
                var annee_mediane = $(this).attr("data-annee_mediane");

                var params = {
                    //id_type_evenement: idTypeEvenement,
                    id_municipalite: idMunicipalite,
                    annee_mediane: annee_mediane
                };

                var callback = function() {
                    wait.stop();

                    var boutonEdition = table.find('.mediane-edition[data-annee_mediane='+annee_mediane+']');
                    boutonEdition.click();
                };

                wait.start();

                $.ajax({
                    type: "POST",
                    url: "/gestion-roles/administration-evaluation/proportion-mediane/creer-mediane/",
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        wait.stop();

                        if (response.hasOwnProperty('erreur')){
                            infos.ajouterMessageToast({
                                message: response.erreur,
                                messageCouleur: "red",
                                messageDuree: 1500,
                                type: 'error'
                            });
                        } else {
                            wait.start();
                            refreshDatatables(callback);
                        }

                    },
                });

            }); // fin de table

            table.find('.mediane-edition').off('click').on('click', function (e) {
                if ($(this).is('[disabled]')) {
                    return false;
                }

                var idEvenement = $(this).attr("data-id_evenement");

                var params = {
                    id_evenement: idEvenement,
                };

                params.callback_fermeture_modal = function () {
                    refreshDatatables();
                };

                tenueAJourModal.ouvrirWizardEvenement(idEvenement, params);
            }); // fin de table

        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
}

function tableFichierMedianeXml(my_div, idMediane) {
    var table = $('.step-pane.active [name=' + my_div + ']');
    table.find('tbody').remove();

    initTableDatatable(table, {
        'paging': false,
        'processing': false,
        "scrollX": true,
        "searching": false,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/json-fichier-mediane-xml/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                d.id_mediane = idMediane;
                wait.stop();
            }
        },

        "columns": [{
            "data": "actions",
            "title": "Statut",
            "width": "70px"
        }, {
            "data": "type_document",
            "title": "Type de document"
        },{
            "data": "date_creation",
            "title": "Date du traitement"
        }],

        "drawCallback": function () {
            table.find('.telecharger-document').off('click').on('click', function (e) {
                var url = $(this).attr("url");
                window.open(url, '_blank');
            });

            table.find('.visualiser-erreur').off('click').on('click', function (e) {
                var idDocument = $(this).attr("data-id");
                tableErreurValidation(idDocument);

                $('#modal-erreur-validation').modal({
                    show: true,
                    backdrop: 'static'
                });
            });

            /*if (origine == 2) {
             var aDonnees = (pageCourante.find('.visualiser-erreur').length > 0);
             table.closest('[name="tableau-produire-extrant"]').toggle(aDonnees);
             }*/

            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
}


function tableDepotRole(idRole) {

    var table = $('#adm-table-depot-role');
    table.find('tbody').remove();

    initTableDatatable(table, {
        'processing': false,
        "scrollX": true,
        "searching": false,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },

        "ajax": {
            "url": "/gestion-roles/administration-evaluation/depot-role/json-depot-role/role/" + idRole + "/origine/1/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS

                wait.stop();
            }
        },

        "columns": [

            {"data": "etape", "title": "Étape"},
            {"data": "actions", "title": "Actions"},
        ],

        "drawCallback": function () {
            function creerProcessus (params, callback) {
                wait.start();

                $.ajax({
                    type: "POST",
                    url: "/gestion-roles/administration-evaluation/depot-role/creer-processus/",
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        wait.stop();

                        if (response.hasOwnProperty('erreur')){
                            infos.ajouterMessageToast({
                                message: response.erreur,
                                messageCouleur: "red",
                                messageDuree: 1500,
                                type: 'error'
                            });
                        } else {
                            wait.start();
                            refreshDatatables(callback);
                            wait.stop();
                        }

                    },
                });
            }

            function ouvrirWizardRole(elem) {
                var idTypeEvenement = elem.attr("data-id_type_evenement");
                var idEvenement = elem.attr("data-id_evenement");
                var idMunicipalite = elem.attr("data-id_municipalite");
                var idProcessus = elem.attr("data-id_processus");
                var idRoleEvaluation = idRole;
                // var idCycle1 = idProcessus

                var params = {
                        id_type_evenement: idTypeEvenement,
                        id_evenement: idEvenement,
                        id_municipalite: idMunicipalite,
                        id_processus: idProcessus,
                        id_role_evaluation: idRoleEvaluation,
                        idCycle1: idProcessus
                };

                params.callback_fermeture_modal = function () {
                    refreshDatatables();
                };

                tenueAJourModal.ouvrirWizardEvenement(idEvenement, params);
            }


            table.find('.depot-role-creation:enabled').off('click').on('click', function (e) {
                if ($(this).is('[disabled]')) {
                    return;
                }
                var idTypeEvenement = $(this).attr("data-id_type_evenement");
                var idEvenement = $(this).attr("data-id_evenement");
                var idMunicipalite = $(this).attr("data-id_municipalite");
                var idProcessus = $(this).attr("data-id_processus");
                var idRoleEvaluation = idRole;

                    var params = {
                        id_type_evenement: idTypeEvenement,
                        id_evenement: idEvenement,
                        id_municipalite: idMunicipalite,
                        id_processus: idProcessus,
                        id_role_evaluation: idRoleEvaluation
                    };

                var callback = function() {
                    var boutonEdition = table.find('.depot-role-edition[data-id_type_evenement='+idTypeEvenement+']');
                    boutonEdition.click();
                };
                creerProcessus(params, callback);

            }); // fin de table

            table.find('.depot-role-edition:enabled').off('click').on('click', function (e) {
                ouvrirWizardRole($(this));
            });

            // Creer un evenement pour le depot de role
            table.find('.depot-role').off('click').on('click', function (e) {
                if ($(this).is('[disabled]')) {
                    return;
                }
                var idTypeEvenement = $(this).attr("data-id_type_evenement");
                var idEvenement = $(this).attr("data-id_evenement");
                var idMunicipalite = $(this).attr("data-id_municipalite");
                var idProcessus = $(this).attr("data-id_processus");
                var anneeExtrant = $(this).attr("data-annee");
                var idRoleEvaluation = idRole;

                var params = {
                    id_type_evenement: idTypeEvenement,
                    id_evenement: idEvenement,
                    id_municipalite: idMunicipalite,
                    id_processus: idProcessus,
                    id_role_evaluation: idRoleEvaluation,
                    annee_extrant: anneeExtrant
                };

                var callback = function() {
                    var boutonEdition = table.find('.depot-role-edit[data-id_type_evenement='+idTypeEvenement+']');
                    boutonEdition.click();
                };
                creerProcessus(params, callback);
            }); // fin de table

            table.find('.depot-role-edit').off('click').on('click', function (e) {
                ouvrirWizardRole($(this));
            });

            table.find('.role-statistique').off('click').on('click', function (e) {

                $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
                $('#modal-message-background').remove();

                //var idCycle = $('#current-cycle').val();
                var idCycle1 = $(this).attr('data-id_cycle');

                $('#adm-body-stats-cycle').empty();

                if (idCycle1) {
                    admGetStatsCycle(idCycle1);
                }


                $('#modal-stats').modal({
                    show: true,
                    backdrop: 'static'
                });

            }); // fin de tables

            table.find('.role-extrant').off('click').on('click', function (e) {
                $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL

                $('#modal-message-background').remove();

                var idCycle1 = $(this).attr('data-id_cycle');

                $('#modal-document-cycle').val(idCycle1);


                $('#modal-document-titre').text('Cycle : ' + $(this).closest('tr').children('td:eq(0)').text());

                var date_fin = $(this).closest('tr').children('td:eq(2)').text();

                $('#adm-body-fichier-cycle').empty();
                $('#adm-body-fichier-cycle-creer').empty();

                if (idCycle1) {
                    var estSuperAdmin = ($('[name=hid-super-admin]').val() == '1');

                    if (date_fin || estSuperAdmin) {
                        admGetFichierCycle(idCycle1, 'adm-body-fichier-cycle', 1);
                    }
                    if (!date_fin || estSuperAdmin) {
                        admGetCreerFichierCycle(idCycle1, 'adm-body-fichier-cycle-creer', 53);
                    }

                    var btnGenerer = $('#btn-generer-modal-document');
                    btnGenerer.toggle((!date_fin || estSuperAdmin));

                    fenetreModal.calculerHauteurModal($('.contenu-principal'));
                    var hauteurNouvelleModal = $(window).height() * 0.75;
                    scroll.ajouterSlimScroll('.contenu-principal', {hauteur: hauteurNouvelleModal});
                }

                $('#modal-document').modal({
                    show: true,
                    backdrop: 'static'
                });

                masquesSelection.init();

                $('#modal-document-select-all-1').change(function () {
                    if ($(this).is(":checked")) {
                        $(':checkbox:not(.disabled)').prop('checked', true);
                    } else {
                        $(':checkbox:not(.disabled)').prop('checked', false);
                    }
                });

                // DM 2019-02-07: ajouté de bout rapidement car le "sélectionner tout" ne fonctionnait pas pour un cycle fermé (issue #7532)
                $('#modal-document-select-all-2').change(function () {
                    if ($(this).is(":checked")) {
                        $('.input-lg-2:not(.disabled)').prop('checked', true);
                    } else {
                        $('.input-lg-2:not(.disabled)').prop('checked', false);
                    }
                });

            });

        }
    });

    $(table).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
}


function tableParametreBaremeComparaison(table) {
    var idRole = $('#current-role').val();
    var divBatiment = table.closest('.panel-group');
    var idAccordeon = divBatiment.attr('id').substring(10);

    if (!$.fn.DataTable.isDataTable(table)) {
        table.find('tbody').remove();

        var columns = [];
        table.find('th').each(function () {
            var nom = $(this).attr('nom');
            var titre = $(this).html();
            var column = {'data': nom, 'title': titre};
            if ((nom == 'bool_selection_comparable') ||
                (nom == 'hascontrainte') ||
                (nom == 'hascontrainterigide') ||
                (nom == 'autresStrate') ||
                (nom == 'bool_exclure_terrain_rajustement')) {
                column['render'] = function(data, type, row, meta) {
                    return data ? "oui" : "non";
                };
            }
            columns.push(column);
        });

        initTableDatatable(table, {
            'processing': true,
            "scrollX": true,
            "searching": true,
            "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
            "bFilter": false,
            "bInfo": false,
            "language": {
                "url": datatable_locale_url
            },
            "paging": true,
            "pageLength": 25,
            "ajax": {
                "url": "/gestion-roles/administration-evaluation/parametre-base-comparaison/accordeon-table-contenu-methode-comparaison",
                "data": function (d) {
                    d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                    d.id_role_evaluation = idRole;
                    d.id_accordeon = idAccordeon;

                    wait.stop();
                }
            },

            "columns": columns,

            "drawCallback": function () {

            }
        });
    }
}

function editer_parametre_base_methode_comparaison(a, id,  object) {
    var idRoleEvaluation = $('#current-role').val();
    var accordeon = $(object).closest('.panel-group');
    var idAccordeon = accordeon.attr('id').substring(10);

    var params = {id_role_evaluation: idRoleEvaluation};
    if (id){
        params.id = id;
    }
    if (idAccordeon){
        params.id_accordeon = idAccordeon;
    }

    var read_only = ($('#content-parametre-comparaison').find('[name=read_only]').val() == '1');
    var titre;
    if (!id) {
        titre = 'Nouveau barème';
    }
    else {
        if (!read_only) {
            titre = 'Éditer le barème';
        }
        else {
            titre = 'Détails du barème';
        }
    }

    var editionParametreBase = {
        id: "modal_parametre_base_methode_comparaison",
        view: "/core/modal/",
        processus_id: "",
        titre: titre,
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/administration-evaluation/parametre-base-comparaison/editer-parametre-comparaison/",
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "grande",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                title: "",
                classSupp: "",
                afficher: true
            },
            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: !read_only,
                id: "btnSauvegardeParametreMethodeComparaison",
                disabled: false
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            var modal = $('#modal_parametre_base_methode_comparaison');
            setTimeout(function() {
                modal.find('[data-toggle="tooltip"]').tooltip();
            }, 100);
            controlesFormulaires.redimentionnerTextarea();
            initmethodecomparaisonfield(modal, idRoleEvaluation, id, idAccordeon);
            var btnSauvegardeParametreMethodeComparaison = $('#btnSauvegardeParametreMethodeComparaison');
            btnSauvegardeParametreMethodeComparaison.off('click').on('click', function (e) {
                var params = get_donnees(modal, idRoleEvaluation, id, idAccordeon);
                let callback2 = () => {
                        wait.start();
                        $.ajax({
                            type: "POST",
                            url: '/gestion-roles/administration-evaluation/parametre-base-comparaison/save-methode-bareme-methode-comparaison/',
                            data:params,
                            dataType: 'json',
                            success: function (response) {
                                wait.stop();
                                if (response.reponse == 'ok') {
                                    if (response.modif !== undefined) {
                                        $('#id_modif').val(response.modif).trigger('change');
                                    }
                                        infos.ajouterMessageToast({
                                            message: 'Sauvegarde réussie',
                                            messageDuree: 500,
                                            icone: 'fa-check-circle-o',
                                            iconeCouleur: 'green'
                                        });
                                    modal.modal('hide');
                                    refreshDatatables();
                                    $('#comparaison-bareme-error').addClass('hidden');
                                    modal.find('[name=message-erreur]').each(function () {
                                        $(this).html('');
                                });
                                } else { // Si on aboutit ici, c'est une erreur de sauvegarde des documents en raison d'une validation sur un champ requis non complété
                        if (response.errors) {
                            modal.find('[name=message-erreur]').each(function () {
                                        $(this).html('');
                                });
                    $.each(response.errors, function (key, value) {
                        let input = modal.find('[name="' + key + '"]');
                        $(input).parent().addClass('has-error');
                        var messageHTML = '<span class="help-block" name="message-erreur">' +  value[0] + '</span><br>';
                        $(messageHTML).insertAfter($(input));
                    });
                }
                                     else {
                                       infos.ajouterMessageToast({
                                        message: "Erreur de sauvegarde : une valeur requise est manquante",
                                        messageCouleur: "red",
                                        messageDuree: 0,
                                        type: 'error'
                                    });
                                     }



                                }
                            }

                        });
                    };
                verifier_modification_role_depose(modal, callback2);
            });

            // gestion affichage et calcul de la somme des poids pour le modele selectionné
            var champ_id_b91_parametre_comparaison = $('form.bareme-comparaison-methode #id_b91ModeleComparaison');
            var champ_id_poid_indice_dissemblance = $('form.bareme-comparaison-methode #id_poid_indice_dissemblance');
            var poids_champ_original = parseFloat($(champ_id_poid_indice_dissemblance).val());
            var poids_help_text = $('#hint_id_poid_indice_dissemblance');
            var poids_total = 0;
            function recharger_poids(){
                wait.start();
                poids_help_text.html('');
                let id_b91_parametre_comparaison = $(champ_id_b91_parametre_comparaison).val();
                if(id_b91_parametre_comparaison){
                    var recharger_poids_cb = function(response) {
                        poids_total = parseFloat(response.poids_total);
                        calculer_poids();
                    };
                    let url = '/gestion-roles/administration-evaluation/parametre-base-comparaison/editer-parametre-comparaison/poids/'+id_b91_parametre_comparaison+'/';
                    call_ajax(url, 'POST', null, recharger_poids_cb, null, false, 'json');
                }else{
                    wait.stop();
                }
            }
            function calculer_poids(){
                let help_text = '';
                if(!isNaN(poids_total)){
                    help_text = 'Poids total actuel pour ce modèle : ' + poids_total + '. ';
                }
                let poids_actuel = parseFloat($(champ_id_poid_indice_dissemblance).val());
                if(!isNaN(poids_actuel) && poids_actuel != poids_champ_original){
                    let poids_calcul = poids_actuel - (poids_champ_original || 0) + poids_total;
                    poids_calcul = poids_calcul.toFixed(3);
                    help_text += 'Nouveau poids total si sauvegardé : ' + poids_calcul + '. ';
                }
                poids_help_text.html(help_text);
                wait.stop();
            }
            $(champ_id_b91_parametre_comparaison).off('change').on('change', function(){recharger_poids();});
            recharger_poids();
            $(champ_id_poid_indice_dissemblance).on('change', function(){calculer_poids();});


            wait.stop();
        }];

        fenetreModal.creerModal(editionParametreBase, params, callbacks);
    }, 0);



}







function tableParametreBase(table) {
    var idRole = $('#current-role').val();
    var divBatiment = table.closest('.panel-group');
    var idAccordeon = divBatiment.attr('id').substring(10);

    if (!$.fn.DataTable.isDataTable(table)) {
        table.find('tbody').remove();

        var columns = [];
        table.find('th').each(function () {
            var nom = $(this).attr('nom');
            var titre = $(this).html();
            columns.push({'data': nom, 'title': titre});
        });

        initTableDatatable(table, {
            'processing': false,
            "scrollX": true,
            "searching": true,
            "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
            "bFilter": false,
            "bInfo": false,
            "language": {
                "url": datatable_locale_url
            },
            "paging": true,
            "pageLength": 25,
            "ajax": {
                "url": "/gestion-roles/administration-evaluation/parametre-base-role/accordeon-table-contenu/",
                "data": function (d) {
                    d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                    d.id_role_evaluation = idRole;
                    d.id_accordeon = idAccordeon;

                    wait.stop();
                }
            },

            "columns": columns,

            "drawCallback": function () {

                table.find('.depot-role-creation').off('click').on('click', function (e) {
                    var idTypeEvenement = $(this).attr("data-id_type_evenement");
                    var idEvenement = $(this).attr("data-id_evenement");
                    var idMunicipalite = $(this).attr("data-id_municipalite");
                    var idProcessus = $(this).attr("data-id_processus");
                    var idRoleEvaluation = idRole;

                    var params = {
                        id_type_evenement: idTypeEvenement,
                        id_evenement: idEvenement,
                        id_municipalite: idMunicipalite,
                        id_processus: idProcessus,
                        id_role_evaluation: idRoleEvaluation
                    };

                    wait.start();

                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/administration-evaluation/depot-role/creer-processus/",
                        data: params,
                        dataType: 'html',
                        success: function (response) {
                            wait.stop();

                            var callback = function() {
                                wait.stop();

                                var boutonEdition = table.find('.depot-role-edition[data-id_type_evenement='+idTypeEvenement+']');
                                boutonEdition.click();
                            };

                            wait.start();
                            refreshDatatables(callback);
                        }
                    });
                }); // fin de table


                table.find('.depot-role-edition').off('click').on('click', function (e) {
                    var idTypeEvenement = $(this).attr("data-id_type_evenement");
                    var idEvenement = $(this).attr("data-id_evenement");
                    var idMunicipalite = $(this).attr("data-id_municipalite");
                    var idProcessus = $(this).attr("data-id_processus");
                    var idRoleEvaluation = idRole;

                    var params = {
                        id_type_evenement: idTypeEvenement,
                        id_evenement: idEvenement,
                        id_municipalite: idMunicipalite,
                        id_processus: idProcessus,
                        id_role_evaluation: idRoleEvaluation
                    };

                    params.callback_fermeture_modal = function () {
                        refreshDatatables();
                    };

                    tenueAJourModal.ouvrirWizardEvenement(idEvenement, params);
                }); // fin de table

            }
        });

        $(table).on('processing.dt', function (e, settings, processing) {
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
    }
}


function tableBaremeCopie() {
    var table = $("#importer-bareme-liste").find('table');
    var idRole = $('#importer-bareme-liste-select').val();
    var idAccordeon = $('#importer-bareme-liste-select').attr('id-accordeon');


    if (!$.fn.DataTable.isDataTable(table)) {
        table.find('tbody').remove();
        var columns = [];
        table.find('th').each(function () {
            var nom = $(this).attr('nom');
            var titre = $(this).html();
            columns.push({'data': nom, 'title': titre});
        });

        initTableDatatable(table, {
            "dom": '<Bif<t>lp>',
            'processing': false,
            "scrollX": true,
            "searching": true,
            "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
            "bFilter": false,
            "bInfo": false,
            "language": {
                "url": datatable_locale_url,
            },
            "paging": true,
            "pageLength": 25,
            "lengthMenu": [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Tous"]],

            "ajax": {
                "url": "/gestion-roles/administration-evaluation/parametre-base-role/importer-bareme-liste/"+idRole+"/"+idAccordeon+"/",
                "data": function (d) {
                    d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                    wait.stop();
                }
            },
            "columns": columns,
            columnDefs: [ {
                orderable: false,
                className: 'select-checkbox',
                targets:   0
            } ],
            buttons: [
                'selectAll',
                'selectNone'
            ],
            select: {
                style:    'multi',
                selector: 'td, th'
            },

        });

        $(table).on('processing.dt', function (e, settings, processing) {
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
         // sur les selections des items du datatable
        $(table)
            .on('select.dt', (e, dt) => callbackSelectionItemImporterBaremeListe(dt))
            .on('deselect.dt', (e, dt) => callbackSelectionItemImporterBaremeListe(dt));
        // on affiche ou masque le bouton d'import en fonction d'une selection présente ou non
        function callbackSelectionItemImporterBaremeListe(dt){
            let nb_items_selected = dt.table().rows('.selected').data().count();
            if(Boolean(nb_items_selected)){
                $('#btnImporterParametreBase').attr('disabled', false);
            }else{
                $('#btnImporterParametreBase').attr('disabled', true);
            }
        }

    }
}



function editer_parametre_base(a, id, object) {
    var idRoleEvaluation = $('#current-role').val();
    var accordeon = $(object).closest('.panel-group');
    var idAccordeon = accordeon.attr('id').substring(10);


    var params = {id_role_evaluation: idRoleEvaluation};
    if (id) {
        params.id = id;
    }
    params.id_accordeon = idAccordeon;

    var read_only = (accordeon.find('[name=read_only]').val() == '1');
    var titre;
    if (!id) {
        titre = 'Nouveau barème';
    }
    else {
        if (!read_only) {
            titre = 'Éditer le barème';
        }
        else {
            titre = 'Détails du barème';
        }
    }

    var editionParametreBase = {
        id: "modal_parametre_base",
        view: "/core/modal/",
        processus_id: "",
        titre: titre,
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/administration-evaluation/parametre-base-role/editer-parametre-base/",
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "grande",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                title: "",
                classSupp: "",
                afficher: true
            },

            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: !read_only,
                id: "btnSauvegardeParametreBase",
                disabled: false
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            var modal = $('#modal_parametre_base');
            var options = {blocsContainer: modal};

            controlesFormulaires.redimentionnerTextarea();
            initSelect2(modal);
            initBlocsCharges(null, null, options);

            masquesSelection.init();

            $('#btnSauvegardeParametreBase').off('click').on('click', function (e) {
                var callback2 = function(response) {
                    if (response.reponse != 'ok') {
                        return;
                    }

                    var options = {
                        modeSave: ModeSave.MENU,
                        blocsContainer: modal,
                        paramsSupp: {sauvegarde_complet: true}
                    };

                    var callback = function (response) {
                        if (response.reponse == 'ok') {
                            if (response.avertissements == undefined) {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie',
                                    messageDuree: 500,
                                    icone: 'fa-check-circle-o',
                                    iconeCouleur: 'green'
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                                    messageDuree: 0,
                                    icone: 'fa-exclamation-triangle',
                                    iconeCouleur: 'orange'
                                });
                            }

                            modal.modal('hide');

                            refreshDatatables();
                        } else { // Si on aboutit ici, c'est une erreur de sauvegarde des documents en raison d'une validation sur un champ requis non complété
                            infos.ajouterMessageToast({
                                message: "Erreur de sauvegarde : une valeur requise est manquante",
                                messageCouleur: "red",
                                messageDuree: 0,
                                type: 'error'
                            });
                        }
                    };
                    saveBlocs(false, callback, options);
                };

                verifier_modification_role_depose(modal, callback2);
            });

            // #15291 Gère les champs obligatoires en fonction de la méthode dépréciation
            // . . . TODO... rendre ça html5: Faire une validation frontend avant de faire le post ajax.
            //  N'est pas le cas pour ce form.
            function gereChampsObligatoiresPourMethodeDepreciation(){
                if($('#form-methodeDepreciation').val()=="3"){
                    // On rends le coefficiant_2 obligatoire
                    $('#form-coefficient_2').parent().prev('label').append('<span class="required text-danger">*</span>');
                }else{
                    $('#form-coefficient_2').parent().prev('label').find('span').remove();
                }
            }
            $('#form-methodeDepreciation').on('change', function(){gereChampsObligatoiresPourMethodeDepreciation();});
            gereChampsObligatoiresPourMethodeDepreciation();

            wait.stop();

        }];
        // TODO: Valider les autorisations et afficher un message correspondant

        fenetreModal.creerModal(editionParametreBase, params, callbacks);
    }, 0);
}

function importer_bareme_modale(a, object) {
    var idRoleEvaluation = $('#current-role').val();
    var accordeon = $(object).closest('.panel-group');
    var idAccordeon = accordeon.attr('id').substring(10);
    var importerParametreBase = {
        id: "modal_importer_bareme",
        view: "/core/modal/",
        processus_id: "",
        titre: "Importer barème(s)",
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/administration-evaluation/parametre-base-role/importer-bareme-modale/"+idRoleEvaluation+"/"+idAccordeon,
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "immense",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                afficher: true,
            },

            {
                type: "save",
                afficher: true,
                label: "Importer la sélection",
                classSupp: "btn-primary",
                id: "btnImporterParametreBase",
                disabled: true
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            var modal = $('#modal_importer_bareme');
            var options = {blocsContainer: modal};

            controlesFormulaires.redimentionnerTextarea();
            initSelect2(modal);
            initBlocsCharges(null, null, options);

            masquesSelection.init();

            $('#importer-bareme-liste-select').on('change', function () {
                wait.start();
                $('#importer-bareme-liste').hide();
                let id_role_evaluation = $('#importer-bareme-liste-select').val();
                if (!id_role_evaluation) {
                    wait.stop();
                    return;
                }

                $('#importer-bareme-liste-table_wrapper table').DataTable().destroy();
                wait.stop();
                tableBaremeCopie();
                $('#importer-bareme-liste').show();

            });

            $('#btnImporterParametreBase').off('click').on('click', function (e) {
                let importer_bareme_callback = function (response) {
                    // pour éviter de continuer à importer si le test verifier_modification_role_depose
                    if (response.reponse != 'ok') {
                        return;
                    }
                    // l'import....
                    wait.start();
                    let idRoleDestination = $('#current-role').val();
                    let idAccordeon = $('#importer-bareme-liste-select').attr('id-accordeon');
                    let params = {ids_baremes:[]};
                    $.each($('#importer-bareme-liste-table').DataTable().rows('.selected').data(), function () {
                        params.ids_baremes.push(this["pk"]);
                    });
                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/administration-evaluation/parametre-base-role/importer-bareme-liste-importer/" + idRoleDestination + "/" + idAccordeon + "/",
                        data: params,
                        dataType: 'json',
                        success: function () {
                            refreshDatatables();
                            infos.ajouterMessageToast({
                                message: 'Copie réussie',
                                messageDuree: 500,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });
                            wait.stop();
                        }
                    });
                };

                let regroupements = $('#importer-bareme-liste-table').DataTable().rows('.selected').data()
                if(regroupements.length<1){
                    return;
                }


                let lignes_confirm = '<ul>';
                $.each(regroupements, function () {
                    lignes_confirm += '<li>'+this.type_regroupement_nom+'</li>';
                });
                lignes_confirm += '<ul>';

                // pour confirmer
                fenetreModal.modalMessage({
                    enteteTitre: 'Attention',
                    titre: "Importation de barèmes et regroupements d'une autre municipalité",
                    texteExplicatif: "Êtes-vous certain de vouloir importer les entrées ci-dessous: "+ lignes_confirm,
                    texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
                    conteneur: "#modal_importer_bareme",
                    taille: "grande",
                    boutons: {
                        "Oui": {
                            label: " Oui ", id: "", class: "btn btn-success",
                            action: function (eee) {
                                let nomodal = $(eee.originalEvent.target).parents('.modal-message-alerte').attr('nomodal');
                                fenetreModal.fermerModalAlerteDivs(false, nomodal);
                                setTimeout(function () {
                                    verifier_modification_role_depose(modal, importer_bareme_callback);
                                }, 50);
                            }
                        },
                        "Non": {
                            label: " Non ", id: "", class: "btn",
                            action: function (eee) {
                                let nomodal = $(eee.originalEvent.target).parents('.modal-message-alerte').attr('nomodal');
                                fenetreModal.fermerModalAlerteDivs(false, nomodal);
                            }
                        }
                    }
                });
            });

            wait.stop();

        }];
        fenetreModal.creerModal(importerParametreBase, {}, callbacks);
    }, 0);
}


function tableParametreTerrain(table) {
    var idRole = $('#current-role').val();

    if (!$.fn.DataTable.isDataTable(table)) {
        table.find('tbody').remove();

        var columns = [];
        table.find('th').each(function () {
            var nom = $(this).attr('name');
            var titre = $(this).html();
            columns.push({'data': nom, 'title': titre});
        });

        table.dataTable({
            'processing': false,
            "scrollX": true,
            "searching": true,
            "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
            "bFilter": false,
            "bInfo": false,
            "language": {
                "url": datatable_locale_url
            },
            "paging": true,
            "pageLength": 25,
            "ajax": {
                "url": "/gestion-roles/administration-evaluation/parametre-base-terrain/table-contenu/",
                "data": function (d) {
                    d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                    d.id_role_evaluation = idRole;

                    wait.stop();
                }
            },

            "columns": columns,

            "drawCallback": function () {

                table.find('.depot-role-creation').off('click').on('click', function (e) {
                    var idTypeEvenement = $(this).attr("data-id_type_evenement");
                    var idEvenement = $(this).attr("data-id_evenement");
                    var idMunicipalite = $(this).attr("data-id_municipalite");
                    var idProcessus = $(this).attr("data-id_processus");
                    var idRoleEvaluation = idRole;

                    var params = {
                        id_type_evenement: idTypeEvenement,
                        id_evenement: idEvenement,
                        id_municipalite: idMunicipalite,
                        id_processus: idProcessus,
                        id_role_evaluation: idRoleEvaluation
                    };

                    wait.start();

                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/administration-evaluation/depot-role/creer-processus/",
                        data: params,
                        dataType: 'html',
                        success: function (response) {
                            wait.stop();

                            var callback = function() {
                                wait.stop();

                                var boutonEdition = table.find('.depot-role-edition[data-id_type_evenement='+idTypeEvenement+']');
                                boutonEdition.click();
                            };

                            wait.start();
                            refreshDatatables(callback);
                        }
                    });
                }); // fin de table


                table.find('.depot-role-edition').off('click').on('click', function (e) {
                    var idTypeEvenement = $(this).attr("data-id_type_evenement");
                    var idEvenement = $(this).attr("data-id_evenement");
                    var idMunicipalite = $(this).attr("data-id_municipalite");
                    var idProcessus = $(this).attr("data-id_processus");
                    var idRoleEvaluation = idRole;

                    var params = {
                        id_type_evenement: idTypeEvenement,
                        id_evenement: idEvenement,
                        id_municipalite: idMunicipalite,
                        id_processus: idProcessus,
                        id_role_evaluation: idRoleEvaluation
                    };

                    params.callback_fermeture_modal = function () {
                        refreshDatatables();
                    };

                    tenueAJourModal.ouvrirWizardEvenement(idEvenement, params);
                }); // fin de table

            }
        });

        $(table).on('processing.dt', function (e, settings, processing) {
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
    }
}


function editer_parametre_terrain(a, id, object) {
    var idRoleEvaluation = $('#current-role').val();

    var params = {id_role_evaluation: idRoleEvaluation};
    if (id) {
        params.id = id;
    }

    var read_only = ($('#content-parametre-terrain').find('[name=read_only]').val() == '1');
    var titre;
    if (!id) {
        titre = 'Nouveau barème';
    }
    else {
        if (!read_only) {
            titre = 'Éditer le barème';
        }
        else {
            titre = 'Détails du barème';
        }
    }

    var editionParametreBase = {
        id: "modal_parametre_terrain",
        view: "/core/modal/",
        processus_id: "",
        titre: titre,
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/administration-evaluation/parametre-base-terrain/editer-parametre-terrain/",
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "tres-grande",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                title: "",
                classSupp: "",
                afficher: true
            },

            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: !read_only,
                id: "btnSauvegardeParametreTerrain",
                disabled: false
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            var modal = $('#modal_parametre_terrain');
            var options = {blocsContainer: modal};

            controlesFormulaires.redimentionnerTextarea();
            initSelect2(modal);
            initBlocsCharges(null, null, options);

            masquesSelection.init();

            var checksMethodes = modal.find('[name=bool_terrain_agricole_boise],[name=bool_terrain_topographie]');
            var methodeChanged = function(e) {
                if (e) {
                    if ($(this).is(':checked')) {
                        checksMethodes.not($(this)).prop('checked', false).trigger('change');
                    }
                }

                var bool_terrain_agricole_boise = modal.find('[name=bool_terrain_agricole_boise]').is(':checked');
                modal.find('[name=container-terrain-agricole-boise]').toggle(bool_terrain_agricole_boise);

                var bool_topographie = modal.find('[name=bool_terrain_topographie]').is(':checked');
                modal.find('[name=container-topographie]').toggle(bool_topographie);

                modal.find('[name=container-autre-methode]').toggle(!bool_terrain_agricole_boise && !bool_topographie);
            };
            checksMethodes.change(methodeChanged);
            methodeChanged(null);


            var methodeAutreChanged = function(obj) {
                var row = obj.closest('.sous-bloc-form');
                var val = obj.val();

                row.find('[name=container-methode-tranche]').toggle(['1', '2', '3', '12', '13'].includes(val));
                row.find('[name=container-methode-formule]').toggle(['4', '5', '6', '7', '8', '9', '10', '14', '15', '16'].includes(val));
                row.find('[name=container-methode-polynomiale]').toggle(val == '11');

                row.find('[name=sup_type]').toggle(['4', '14', '15'].includes(val));
                row.find('[name=prof_type]').toggle(['5', '12', '15', '16'].includes(val));
                row.find('[name=front_type]').toggle(['6', '14', '16'].includes(val));

                var lblTauxValeurContenu = 'Taux';
                if (val == '13') {
                    lblTauxValeurContenu = 'Valeur fixe';
                }

                row.find('[name=lbl_taux_valeur]').text(lblTauxValeurContenu);

            };
            modal.find('[name=typeMethodeCalculTerrain]').change(function() {
                methodeAutreChanged($(this));
            });

            modal.find('[name=typeMethodeCalculTerrain]').each(function() {
                methodeAutreChanged($(this));
            });

            var valeurChanged = function(obj) {
                var row = obj.closest('.sous-bloc-form');

                row.find('[name=de_1]').text('0');

                for (var i = 2; i < 10; i++) {
                    var valeur_prec = row.find(`[name='valeur_${i-1}']`).val();
                    row.find(`[name="de_${i}"]`).text(valeur_prec);
                }
                // la dernière tranche n'a pas de "champs" "DE" ni "À", on veut quand même afficher l'information
                // quand la 5ème tranche est renseignée
                // on commence par effacer les valeurs
                row.find('[name="de_10"]').val('');
                row.find('[name="de_10"]').text('');
                var valeur_9 = row.find('[name="valeur_9"]').val();
                if(valeur_9){
                    row.find('[name="de_10"]').text(valeur_9);
                }
            };
            modal.find("[name^='valeur_']").change(function() {
                valeurChanged($(this));
            });

            $('#bareme-methode-calcul-terrain-sous-bloc .sous-bloc-form>:first-child').each(function() {
                valeurChanged($(this));
            });

            var coefficientChanged = function(obj) {
                var row = obj.closest('.sous-bloc-form');

                var degre = 0;
                var lettres = ['a', 'b', 'c', 'd'];

                for (let i = 0; i < 4; i++) {
                    let lettre = lettres[i];
                    var val = row.find('[name=coefficient_'+lettre+']').val();
                    if (val) {
                        degre = i + 1;
                    }
                }

                for (let i = 0; i < 4; i++) {
                    let lettre = lettres[i];
                    var position = degre - i;
                    var lbl_variable = '';
                    if (position > 0) {
                        lbl_variable = 'x^' + position;
                    }

                    row.find('[name=coeff_'+lettre+']').text(lbl_variable);
                }
            };
            modal.find('[name=coefficient_a],[name=coefficient_b],[name=coefficient_c],[name=coefficient_d]').change(function() {
                coefficientChanged($(this));
            });

            $('#bareme-methode-calcul-terrain-sous-bloc .sous-bloc-form>:first-child').each(function() {
                coefficientChanged($(this));
            });

            var btnSauvegardeParametreTerrain = $('#btnSauvegardeParametreTerrain');

            btnSauvegardeParametreTerrain.off('click').on('click', function (e) {
                var callback2 = function(response) {
                    if (response.reponse != 'ok') {
                        return;
                    }

                    // des champs comme "constante" et "profondeur_type" sont doublés. Annuler ceux qui sont cachés pour prendre seulement les valeurs appropriées
                    var champsExclure = $();
                    modal.find('.sous-bloc-form').each(function () {
                        if ($(this).find('[name="container-methode-tranche"]').is(':hidden')) {
                            champsExclure = champsExclure.add($(this).find('[name="container-methode-tranche"] .form-control'));
                        }
                        if ($(this).find('[name="container-methode-formule"]').is(':hidden')) {
                            champsExclure = champsExclure.add($(this).find('[name="container-methode-formule"] .form-control'));
                        }
                        if ($(this).find('[name="container-methode-polynomiale"]').is(':hidden')) {
                            champsExclure = champsExclure.add($(this).find('[name="container-methode-polynomiale"] .form-control'));
                        }
                    });

                    champsExclure.each(function () {
                        $(this).attr('name', $(this).attr('name') + '_TEMP');
                        $(this).attr('id', $(this).attr('id') + '_TEMP');
                    });

                    var sousBlocsExclure = modal.find('.sous-bloc-form:hidden');
                    sousBlocsExclure.removeClass('sous-bloc-form');

                    var options = {
                        modeSave: ModeSave.MENU,
                        blocsContainer: modal,
                        paramsSupp: {sauvegarde_complet: true}
                    };

                    var callback = function (response) {
                        champsExclure.each(function () {
                            $(this).attr('name', $(this).attr('name').replace('_TEMP', ''));
                            $(this).attr('id', $(this).attr('id').replace('_TEMP', ''));
                        });
                        sousBlocsExclure.addClass('sous-bloc-form');

                        if (response.reponse == 'ok') {
                            if (response.avertissements == undefined) {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie',
                                    messageDuree: 500,
                                    icone: 'fa-check-circle-o',
                                    iconeCouleur: 'green'
                                });
                                // rechargement de la modale
                                fenetreModal.creerModal(...fenetreModal._dernieremodal_all);
                            } else {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                                    messageDuree: 0,
                                    icone: 'fa-exclamation-triangle',
                                    iconeCouleur: 'orange'
                                });
                            }

                            // patch pour ne pas perdre les données de l'ancienne méthode lorsqu'on change pour une nouvelle méthode
                            var rowsCachees = modal.find('.sous-bloc-form:hidden').not('.nouvelle-ligne');

                            rowsCachees.attr('id-model-instance', 'None');
                            rowsCachees.attr('methode', 'POST');
                            rowsCachees.find('.form-control:eq(0)').addClass('valeur-modifiee controle-modifie');

                            refreshDatatables();
                        } else { // Si on aboutit ici, c'est une erreur de sauvegarde des documents en raison d'une validation sur un champ requis non complété
                            infos.ajouterMessageToast({
                                message: "Erreur de sauvegarde : une valeur requise est manquante",
                                messageCouleur: "red",
                                messageDuree: 0,
                                type: 'error'
                            });
                        }
                    };
                    saveBlocs(false, callback, options);
                };

                verifier_modification_role_depose(modal, callback2);
            });

            wait.stop();
        }];
        // TODO: Valider les autorisations et afficher un message correspondant

        fenetreModal.creerModal(editionParametreBase, params, callbacks);
        // pour permettre de recharger la modale une fois la sauvegarde réussie, on conserve les arguments de création.
        fenetreModal._dernieremodal_all = [editionParametreBase, params, callbacks];
    }, 0);
}


function supprimer_parametre_role(a, id, object) {
    var accordeon = $(object).closest('.panel-group');
    var idAccordeon = accordeon.attr('id').substring(10);

    fenetreModal.modalMessage({
        enteteTitre: "Voulez-vous vraiment supprimer ce barème ?",
        texteExplicatif: "<br />ATTENTION: CETTE ACTION EST IRRÉVERSIBLE",
        texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
        sansX: true,
        conteneur: "#page_content",
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    var params = {
                        id: id,
                        id_accordeon: idAccordeon
                    };

                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/administration-evaluation/parametre-base-role/supprimer-parametre-role/",
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop();

                            var callback = function() {
                                wait.stop();
                            };

                            wait.start();
                            refreshDatatables(callback);
                        }
                    });
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });
}

function supprimer_parametre_terrain(a, id, object) {
    fenetreModal.modalMessage({
        enteteTitre: "Voulez-vous vraiment supprimer ce barème ?",
        texteExplicatif: "<br />ATTENTION: CETTE ACTION EST IRRÉVERSIBLE",
        texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
        sansX: true,
        conteneur: "#page_content",
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    var params = {id: id};

                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/administration-evaluation/parametre-base-terrain/supprimer-parametre-terrain/",
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop();

                            var callback = function() {
                                wait.stop();
                            };

                            wait.start();
                            refreshDatatables(callback);
                        }
                    });
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });
}

function verifier_modification_role_depose(modal, callback) {
    var response = {reponse: 'ok'};

    let est_role_deja_depose = modal.find('.wiz-validation-erreur').length;
    let est_b93_lies_suppression = false;
    let est_changement_methode_et_b93_lies = false;

    // #13892: gestion avertissement suppression des b93 tranches terrains liées
    // vérifie qu'on est en Méthode topographie
    if($('[name="bool_terrain_topographie"]').attr('value')){
        // detecte que l'on ait lancé une suppression de méthode topo
        let lignes_a_supprimer = $('#bareme-terrain-topographie-sous-bloc').find('[methode="DELETE"]');
        // récupère le nombre de b93 affectés
        let tot=0;
        lignes_a_supprimer.find('[name="get_nb_b93_tranche_terrain"]').each(function(e){tot += parseInt($(this).val());});
        if(tot>0){
            est_b93_lies_suppression = true;
        }
    }
    // si on bascule vers la méthode terrain agricole
    if($('[name="bool_terrain_agricole_boise"]').hasClass('valeur-modifiee')){
        // on récupère le total des entrées b93 susceptibles d'êtres supprimées au changement de méthode
        let tot = 0;
        $('#bareme-terrain-topographie').find('[name="get_nb_b93_tranche_terrain"]').each(function(e){tot += parseInt($(this).val());});
        if(tot>0){
            est_changement_methode_et_b93_lies = true;
        }
    }
    if (est_role_deja_depose || est_b93_lies_suppression || est_changement_methode_et_b93_lies) {
        let texteExplicatif = '';
        if(est_role_deja_depose){
            texteExplicatif += "- Le rôle est déjà déposé: Toute modification sur un rôle déjà déposé peut avoir des répercussions catastrophiques.";
            if(est_b93_lies_suppression || est_changement_methode_et_b93_lies){
                texteExplicatif += '<br/><br/>';
            }
        }
        if(est_b93_lies_suppression || est_changement_methode_et_b93_lies){
            texteExplicatif += "- Des calculs existants font références à ce barème et <strong>SERONT SUPPRIMÉS</strong><br/>";
        }
        texteExplicatif += '<br/><br/>ATTENTION: CETTE ACTION EST IRRÉVERSIBLE<br/> Continuer?';
        fenetreModal.modalMessage({
            enteteTitre: "Attention",
            texteExplicatif: texteExplicatif,
            texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
            sansX: true,
            conteneur: "#page_content",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        callback(response);
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        response.reponse = 'cancel';
                        callback(response);
                    }
                }
            }
        });
    }
    else {
        callback(response);
    }
}


function init_nb_regroupement_popover(){
    let popover_elem = $('.nb_regroupement_popover');

     let popover_nb_regroup_link = $(popover_elem).find('.nb_regroupement_popover_link').popover({
       html : true,
       title:function(){
          return $('.popover_title').html();
       },
       content:function(){
          return $(popover_elem).find('.nb_regroupement_popover_wrapper').html();
       },
    });

     $(popover_nb_regroup_link).on('shown.bs.popover', function () {
        $('#'+$(this).attr('aria-describedby')).find('.nb_type_regroupement_recalculer').off('click').on('click', function(){
            let popo = $(this).parents('.popoverjust4ref');
            regroupement_get_nb_dans_regroupement($(popo).data('id_municipalite'), $(popo).data('id_type_regroupement'),
                $('#type-regroupement').find('[name="nb_dans_regroupement"]'));
        });
    });



}
$(document).on('click','.close-popover',function(){
  $('.nb_regroupement_popover_link').popover('hide');
});


function regroupement_get_nb_dans_regroupement(municipalite_id, type_regroupement_id, nb_input){
    $(nb_input).hide();
    var load_icon = '<i class="ace-icon fa fa-spinner fa-spin" id="loading_nb_dans_regroupement"></i>';
    $(nb_input).before(load_icon);

    let url = "/gestion-roles/regroupement/get-nb-dans-regroupement/"+municipalite_id+"/"+type_regroupement_id;
    let recalculer = false;
    if($(nb_input).attr('popoverid')){
        $('#'+$(nb_input).attr('popoverid')).remove();
        url = url + '/recalculer';
        recalculer = true;
        $(nb_input).attr('popoverid', '');
    }

    $.ajax({
        type: "GET",
        url: url,
        data: {'recalculer': recalculer},
        dataType: 'json',
        success: function (response) {
            $('#loading_nb_dans_regroupement')[0].remove();
              let where = "type_regroupement_just4ref_"+typeRegroupementInitPopover.typeRegroupementPopoverId;
              $(nb_input).before('<div id="'+where+'" class="popoverjust4ref" data-id_municipalite="'+
                  municipalite_id +'" data-id_type_regroupement="'+type_regroupement_id+'"></div>');
              $('#'+where).html(response["template"]);
              $(nb_input).attr('popoverid', where);
              init_nb_regroupement_popover(typeRegroupementInitPopover.typeRegroupementPopoverId);
        },
        error: function(response){
            console.log('error nb_dans_regroupement:' + response.statusText);
        }

    });
}


function creerEditerTypeRegroupement(idTypeRegroupement=false, bool_regroupement_base=false, titre='Créer un regroupement') {
    var read_only = Boolean(bool_regroupement_base);
    if(change_typeregroupement===false){
        read_only=true;
    }
    var id_municipalite = $('#adm-liste-ville').val();
    var params = {};
    params.id_municipalite=id_municipalite;
    params.id=idTypeRegroupement;
    params.bool_regroupement_base=bool_regroupement_base;

    var modalconfig = {
        id: "type-regroupement",
        view: "/core/modal/",
        processus_id: "",
        titre: titre,
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/regroupement/ouvrir-edition-regroupement/",
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "tres-grande",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                title: "",
                classSupp: "fermemoi",
                afficher: true
            },
            {
                type: "delete",
                label: "Supprimer",
                title: "",
                classSupp: "btn-secondary",
                afficher: !read_only,
                id: "supprimer-type-regroupement",
                disabled: false
            },

            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: !read_only,
                id: "sauvegarder-type-regroupement",
                disabled: false
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            callbackcreerEditerTypeRegroupement(params);
        }];
        fenetreModal.creerModal(modalconfig, params, callbacks);
        $('#type-regroupement').attr('stop-le-spinner-on-close', 'svp'); // #14691
    }, 0);



}

// Récupère le data du template, des choix de champs disponibles
var typeregroupementxvariable_champs;
// Les baremes reliés au Type de Regroupement en cours
var typeregroupement_baremes_relies;
function initTypeRegroupementJSVariables(){
    typeregroupementxvariable_champs = JSON.parse(document.getElementById('typeregroupementxvariable_champs').textContent);
    typeregroupement_baremes_relies = JSON.parse(document.getElementById('typeregroupement_baremes_relies').textContent);
}



var jq_sel_form = 'form#type-regroupement';
var jq_sel_lines = jq_sel_form+'>#type-regroupement-x-variable .sous-bloc-form';


function getTypeRegroupementXVariableChampStr(typeregroupxvariable_line_elem){
    let champchamp = $(typeregroupxvariable_line_elem).find('[name="champ"]');
    return typeregroupementxvariable_champs[$(champchamp).val()];
}
function selectTypeRegroupementXVariableChamp(element=false){
    /*
     Gère l'affichage des 'champs valeurs' (en place de valeur1, valeur2)
     utilisé lors de l'initialisation de la popup d'édition et au changement
     des valeurs (par ligne) du champ 'champ' (choix de la condition).
     - element: hors de l'initialisation principale on traite directement le champ triggered.
     */

    let jq_sel_champs = jq_sel_lines + ' [name="champ"]';
    if(element){
        jq_sel_champs = $(element);
    }
    $(jq_sel_champs).each(function( index ) {
        let une_ligne = $(this).parents('.row').first();

        // Cache/réinitialise tous les champs-valeurs
        $(une_ligne).find('.typeregroupxvariableextrafield').removeClass('champchampselected1').removeClass('champchampselected2').hide();

        // cache les champs de bases valeur_1 et 2
        $(une_ligne).find('[name="valeur_1"]').hide();
        $(une_ligne).find('[name="valeur_2"]').hide();

        // obtient le nom du champ valeur en fonction du choix du champ 'champ'
        // ex.: b01_renseignements_generaux__nb_etage
        let champ_str = typeregroupementxvariable_champs[$(this).val()];

        // récupération de l'élément valeur du champ (1 et 2)
        var lechampenquestion_1 = $(une_ligne).find('[name="'+champ_str+'_1"]');
        var lechampenquestion_2 = $(une_ligne).find('[name="'+champ_str+'_2"]');

        // Affiche Nos deux champs-valeurs
        // classe 'champchampselected' est ajouté pour faciliter leurs selection dans le callback de typeOperateur
        $(lechampenquestion_1).parents('.typeregroupxvariableextrafield').removeClass('col-xs-0').addClass('col-xs-3 champchampselected1').show();
        $(lechampenquestion_2).parents('.typeregroupxvariableextrafield').removeClass('col-xs-0').addClass('col-xs-3 champchampselected2').show();
    });

    // effectue la mécanique du select du champ opérateur
    selectTypeOperateur(element);
}




function addMultiInput(elemrow){
    /*
    * TypeRegroupement Add/Edit : Utilisé lorsque un TypeRegroupementXVariable a son champ 'TypeOperateur' = 'dans liste'
    *  transforme le champ en selec2 option multiple
    * elemrow : la ligne 'row sous-bloc-form' trxv
    */
    let elemname = getTypeRegroupementXVariableChampStr(elemrow)+"_1";
    let jq_champ = $(elemrow).find('[name="'+elemname+'"]');
    jq_champ.attr('multiple', 'multiple');
    // enlever la valeur vide des choix possibles
    jq_champ.find('option[value=""]').remove();

    let valeurs_initiales = $(elemrow).find('[name="valeur_1"]').val();

    let readonly = false;
    if($('#type-regroupement').data('typeregroupement_modal')._mode == 'readonly'){
        readonly = true;
    }

    // 2 cas: les champs déja select, et les autres.
    let est_liste = jq_champ.is('select');
    if(est_liste){
        // selectionner chaque option de valeurs_initiales
        if(valeurs_initiales){
            $(valeurs_initiales.split(',')).each(function(){
                let valeur_initiale = this.replaceAll('\'','');
                let option_initiale = jq_champ.find('option[value="'+valeur_initiale+'"]');
                if(option_initiale.length){
                    option_initiale[0].selected = true;
                }else{
                    console.log('attention: option initiale non trouvée valeur=['+valeur_initiale+'] pour champ=['+jq_champ+']');
                }
            });
        }
        let jq_champ_multi = $(elemrow).find('[name="'+elemname+'_multi'+'"]');
        jq_champ.on('change', function(e){
            jq_champ_multi.val($(this).val());
        });
        jq_champ.select2();
        if(readonly){
            jq_champ.select2("readonly", true);
        }
    }else{
        // champs libres: on doit recréer un select2 multiple en mode tags. on masque le champ original.
        var jq_champ_id = jq_champ.attr('id');
        var jq_champ_name = jq_champ.attr('name');
        jq_champ.attr('id', jq_champ_id+'_old');
        jq_champ.attr('name', jq_champ_name+'_old');
        // on doit masquer le champ original et tous ses possibles wrappers:
        jq_champ.parents('.typeregroupxvariableextrafield').children().hide();
        // puis insérer notre nouveau champ au meme niveau que le plus haut des wrappers
        jq_champ.parents('.typeregroupxvariableextrafield').append('<input type="text" id="'+jq_champ_id+'" name="'+jq_champ_name+'" />');
        // ainsi que le champ synthétique hidden _multi
        jq_champ.parents('.typeregroupxvariableextrafield').append('<input type="hidden" id="'+jq_champ_id+'_multi" name="'+jq_champ_name+'_multi" />');
        var new_jq_champ = $(elemrow).find('[name="'+jq_champ_name+'"]');
        var new_jq_champ_multi = $(elemrow).find('[name="'+jq_champ_name+'_multi"]');

        new_jq_champ.select2({
            tags:true,
            tokenSeparators: [' ', ';'],
            multiple:true,
            width:'100%',
            createTag: function(params) {
              const term = $.trim(params.term);
              if (term.slice(-1) === ',') {
                return null; // Block empty tag creation
              }
              return { id: term, text: term };
            },
            dropdownCss: {display:'none'}, // masque la dropdown de sélection d'options (champ libre!)
        });
        new_jq_champ.on('change', function(e){
            console.log('nouvelles valeurs=['+$(this).val()+'], on maj le _multi');
            new_jq_champ_multi.val($(this).val());
            jq_champ.val($(this).val()).trigger('change'); //trigger ligne/champ modifiee sur input original.
        });
        if(valeurs_initiales){
            new_jq_champ.val(valeurs_initiales);
            new_jq_champ.trigger('change');
        }
        if(readonly){
            new_jq_champ.select2("readonly", true);
        }

    }// else = not est_liste
}


// callback change sur le select typeOperateur
function selectTypeOperateur(element=false){
    var show_val2_header = false;

    // Nos champs 'typeoperateurs'. cas d'initialisation pour toute la modale
    var jq_sel_typeoperateurs = jq_sel_lines+ ' [name="typeOperateur"]';
    // Cas à la pièce.
    if(element){
        jq_sel_typeoperateurs = $(element);
    }
    $(jq_sel_typeoperateurs).each(function( index ) {
        var une_ligne = $(this).parents('.row').first();
        // Opérateur 'entre' Gère affichage valeur_1 / valeur_2
        if($(this).val() == "4" || $(this).val() == "Entre"){
            $(une_ligne).find('.champchampselected1').removeClass('col-xs-6').addClass('col-xs-3');
            $(une_ligne).find('.champchampselected2').show();
            show_val2_header = true;
        }else{
            $(une_ligne).find('.champchampselected2').hide();
            $(une_ligne).find('.champchampselected1').removeClass('col-xs-3').addClass('col-xs-6');
        }
        // Opérateur Liste
        if($(this).val() == "5" || $(this).val() == "11"){
            let sous_bloc_form = une_ligne.parents('.sous-bloc-form');
            une_ligne.find('.multi_wrap').show();
            addMultiInput(sous_bloc_form);
        }else{
            une_ligne.find('.multi_wrap').hide();
        }
    });
    // gère le header valeur 2
    if(show_val2_header){
        $('.valeur_2_header_selector').show();
    }else{
        $('.valeur_2_header_selector').hide();
    }

}

// La popup de Création/Edition
function callbackcreerEditerTypeRegroupement(params){
    //////////////////////////////////////////////////////
    // INIT MODAL OPEN
    //////////////////////////////////////////////////////
    var modal = $('#type-regroupement');
    modal._id_municipalite = params['id_municipalite'];
    modal._mode = 'create';
    modal._changed = false;
    var options = {blocsContainer: modal};

    // hides all extra fields
    $('.typeregroupxvariableextrafield').hide();

    initBlocsCharges(null, null, options);

    if(params['id'] && params['id_municipalite']){
        modal._mode = 'edit';
        modal._instance_id = params['id'];
        /* // désactivé temporairement via #31031
        regroupement_get_nb_dans_regroupement(params['id_municipalite'], params['id'] , modal.find('[name="nb_dans_regroupement"]'));
        */
    }
    if(params.bool_regroupement_base){
        modal._mode = 'readonly';
    }
    $('#type-regroupement').data('typeregroupement_modal', modal);

    initTypeRegroupementJSVariables();
    selectTypeRegroupementXVariableChamp();

    formaterMonnaie(modal.find('input.money'), 0);

    // Gère le changement de valeur du champ 'champ' (choix de la condition)
    $('form#type-regroupement [name="champ"]').change(function () {
        selectTypeRegroupementXVariableChamp($(this));
        $(this).attr('disabled', 'disabled'); // bloque l'édition
        // active le champ typeOperateur
         $($(this).parents('.row')[0]).find('[name="typeOperateur"]').removeAttr('disabled')
    });
    // champ 'operateur'
    $('form#type-regroupement [name="typeOperateur"]').change(function () {
        selectTypeOperateur($(this));
        $(this).attr('disabled', 'disabled'); // bloque l'édition
    });

    modal.find(".fermemoi").off('click').on('click', function (e) {
        if(modal._changed){
            wait.start();
            refreshDatatables(function(e){
                $('table[name="gestion_regroupement"]').css("width", "100%");
                if(change_typeregroupement===false){
                    $('table[name="gestion_regroupement"]').find('.fa-pencil-square-o').removeClass('fa-pencil-square-o').addClass('fa-eye');
                }
            });
        }
        modal.modal('hide');
    });

    var baremes_affectes_message = "";
    $(Object.keys(typeregroupement_baremes_relies)).each(function(k,v){
        baremes_affectes_message += "- "+v+": "+typeregroupement_baremes_relies[v]+"<br/>";
    });


    $('#sauvegarder-type-regroupement').off('click').on('click', function (e) {
        var id_municipalite = $('#adm-liste-ville').val();
        // BUG: plusieurs dom element avec ID type-regroupement.
        // var id_type_regroupement_pour_edit = $('#type-regroupement').attr('');
        // Donc... moins direct mais fonctionne, pour l'instant
        var id_type_regroupement_pour_edit = $('.blocForm').attr('id_model_instance');
        var options = {
            modeSave: ModeSave.MENU,
            blocsContainer: modal,
            id_municipalite: id_municipalite,
            paramsSupp: {
                sauvegarde_complet: true,
                id_municipalite: id_municipalite,
                id_type_regroupement_pour_edit: id_type_regroupement_pour_edit
            }
        };


        var callback_sauvegarder_regroupement = function (response) {
            if (response.reponse == 'ok') {
                if (response.avertissements == undefined) {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie',
                        messageDuree: 500,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green'
                    });
                } else {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                        messageDuree: 0,
                        icone: 'fa-exclamation-triangle',
                        iconeCouleur: 'orange'
                    });
                }
                var id_instance;
                if(modal._mode == 'create'){
                    // On vient de créer une instance, on recharge la popup avec.
                    id_instance = response.orginal_response.main['type-regroupement'].params['id_instance'];
                    creerEditerTypeRegroupement(id_instance, false, 'éditer');
                }else{
                    //edit
                    id_instance = modal._instance_id;
                }
                modal._changed = true;

            } else {
                infos.ajouterMessageToast({
                        message: "Erreur de sauvegarde : une valeur requise est manquante",
                        messageCouleur: "red",
                        messageDuree: 0,
                        type: 'error'
                    });
            }
        };
        // Utilisé pour les deux potentielles modales de confirmations...
        let sauvegarder = true;

        if(typeregroupement_baremes_relies && !$.isEmptyObject(typeregroupement_baremes_relies) && !params['bool_regroupement_base']){
            sauvegarder = false;

                fenetreModal.modalMessage({
                    enteteTitre: "Attention",
                    titre: "Des barèmes font références à ce regroupement:",
                    sansX: true,
                    texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
                    texteExplicatif: baremes_affectes_message,
                    contenuFormulaire: "Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action:  function () {
                                sauvegarder = true;
                                close_typereg_bareme_modal_and_next();
                            },
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                    fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }
                });
            function close_typereg_bareme_modal_and_next(){
                fenetreModal.fermerModalAlerteDivs();
                setTimeout(function () {
                    typereg_test_uv_and_save();
                }, 200);
            }
        }else{
            typereg_test_uv_and_save();
        }
        function typereg_test_uv_and_save(){
            // Test pour UV potentiellement sélectionnées
            var avertissement_uv = '';
            modal.find(".sous-bloc-form").each(function(){
                // Si le champ "champ" est unité de voisinage
                if($(this).find("[name='champ']").val()=="25"){
                    // TODO: différents tests en fonction des opérateurs
                    // let operateur = $(this).find("[name='typeOperateur']").val()
                    let val_1_elem = $(this).find("#form-b00_identification__id_unite_voisinage_1");
                    let val_2_elem = $(this).find("#form-b00_identification__id_unite_voisinage_2");
                    function test_uv_get_message_erreur(uv_elem){
                        if(uv_elem.length && (uv_elem.val() != "")){
                            let uv_selected = $(uv_elem).find(':selected');
                            if(uv_selected.length){
                                var date_fin = uv_selected.data()['date_fin'];
                                if(new Date(date_fin) < new Date()){
                                    avertissement_uv += ""+uv_elem.val()+" ("+date_fin+")\n<br/>";
                                }
                            }
                        }
                    }
                    test_uv_get_message_erreur(val_1_elem);
                    test_uv_get_message_erreur(val_2_elem);
                }
            });
            if(avertissement_uv){
                    fenetreModal.modalMessage({
                        enteteTitre: "Attention",
                        titre: "Des unités de voisinage ont leur date de fin dans le passé:",
                        sansX: true,
                        texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
                        texteExplicatif: avertissement_uv,
                        contenuFormulaire: "Voulez-vous continuer ?",
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action:  function () {
                                    saveBlocs(false, callback_sauvegarder_regroupement, options);
                                },
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                        fenetreModal.fermerModalAlerteDivs();
                                }
                            }
                        }
                    });
            }else if(sauvegarder){
                saveBlocs(false, callback_sauvegarder_regroupement, options);
            }
        }



    });
    // var delete_regroupement_bouton_html = ' <button data-toggle="tooltip"  data-placement="top" id="supprimer-type-regroupement" title="" className="btn btn-sm btn-primary"> <i className="ace-icon fa fa-trash-o"></i>Supprimer </button>';
    // modal.find('#sauvegarder-type-regroupement').before(delete_regroupement_bouton_html)


    $('#supprimer-type-regroupement').off('click').on('click', function (e) {
            if(baremes_affectes_message){
                    fenetreModal.modalMessage({
                        enteteTitre: "Attention",
                        titre: "Des barèmes font références à ce regroupement:",
                        sansX: true,
                        texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
                        texteExplicatif: baremes_affectes_message,
                        contenuFormulaire: "Vous devez préalablement retirer l'usage de ce regroupement dans ces barèmes et recharger à nouveau ce regroupement.",
                        boutons: {
                            "Ok": {
                                label: " Ok ",
                                id: "",
                                class: "btn",
                                action: function () {
                                        fenetreModal.fermerModal("type-regroupement");
                                }
                            }
                        }
                    });
            }else{
                fenetreModal.modalMessage({
                    enteteTitre: "Attention",
                    titre: "Suppression du regroupement:",
                    sansX: true,
                    texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
                    texteExplicatif: baremes_affectes_message,
                    contenuFormulaire: "Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action:  function () {
                                supprimer_regroupement(e);
                            },
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                $('button.appliquer-filtre').click();
                                fenetreModal.fermerModalAlerteDivs("type-regroupement");
                            }
                        }
                    }
                });
            }

    });
    function supprimer_regroupement(e){
        wait.start();
        let municipalite_id = $('#adm-liste-ville').val();
        $.ajax({
            type: "POST",
            url: "/gestion-roles/regroupement/supprimer-regroupement/" + municipalite_id + "/" + modal._instance_id,
            dataType: 'json',
            success: function (response) {
                wait.stop();
                if (response == "supprime") {
                    infos.ajouterMessageToast({
                        message: "Regroupement supprimé avec succès<br/>",
                        messageDuree: 5000,
                        messageCouleur: "green"
                    });
                    $('button.appliquer-filtre').click();
                    fenetreModal.fermerModal("type-regroupement");
                } else {
                    infos.ajouterMessageToast({
                        message: response,
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                }

            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                infos.ajouterMessageToast({
                    message: "Erreur de suppression du regroupement. Contacter un administrateur. [" + textStatus + ": " + errorThrown + "]",
                    messageDuree: 5000,
                    messageCouleur: "red"
                });
            }
        });
    }

    // #16174: en mode consultation on souhaite afficher les valeurs "inconnues" telle qu'en BD (non liées à des entrées en bd)
    if(modal._mode=="readonly"){
        $("#type-regroupement-x-variable .champchampselected1").each(function () {
            let input_val_inconnu_val1 = $(this).find('input');
            if(input_val_inconnu_val1.val()=="Inconnu"){
                input_val_inconnu_val1.val($(this).parent().find("#form-valeur_1").val());
                input_val_inconnu_val1.css("border", "1px solid red");
                $('#regroupements-avertissement-inconnu').show();
            }
        });
        $("#type-regroupement-x-variable .champchampselected2").each(function () {
            let input_val_inconnu_val2 = $(this).find('input');
            if(input_val_inconnu_val2.val()=="Inconnu"){
                input_val_inconnu_val2.val($(this).parent().find("#form-valeur_2").val());
                input_val_inconnu_val2.css("border", "1px solid red");
                $('#regroupements-avertissement-inconnu').show();
            }
        });
    }

    wait.stop();
}

function importerDataTableZonage(forcerefresh=false) {
    var id_municipalite = $('#adm-liste-ville').select2('val');
    //    On charge les zonages
    var nomTableDataTable = 'adm-table-zonage';
    var $tableDataTable = $('#' + nomTableDataTable);
    if ( $.fn.dataTable.isDataTable($tableDataTable) && !forcerefresh ){
        return;
    }
    tableZonage = initTableDatatable($tableDataTable, {
        ajax: {
            url: '/gestion-roles/administration-evaluation/municipalite/' + encodeURIComponent(id_municipalite) + '/zonage/',
            data: function (d) {
                // d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
            }
        },
        async: false, // Si True, les listes des filtres s'écrasent dans la dernière liste de sélection puisque la
        // génération des boutons arrive après la fin de l'exécution ajax.
        order: [[1, 'asc']],
        processing: false,
        scrollX: false,
        responsive: false,
        searching: true,
        columnDefs: [
            {
                title: "Numéro de zonage",
                targets: 0,
                data: "no_zonage_municipal",
                sortable: true,
                render: function (data, type, row) {
                    if (data !== null) {
                        return data;
                    } else {
                        return data;
                    }
                }
            },
            {
                title: "Nom du zonage",
                targets: 1,
                data: "unicode"
            },
            {
                title: "Description",
                targets: 2,
                data: "description",
                sortable: false,
                render: function (data, type, row) {
                    if (data !== null) {
                        return data;
                    } else {
                        return data;
                    }
                }
            },
            {
                title: "Date début",
                targets: 3,
                data: "date_debut",
                width: '150px',
                sortable: true,
                render: function (data, type, row) {
                    if (data !== null) {
                        var date = data.split('T')[0];
                        return date;
                    } else {
                        return data;
                    }
                }
            },
            {
                title: "Date fin",
                targets: 4,
                width: '150px',
                data: "date_fin",
                sortable: true,
                render: function (data, type, row) {
                    if (data !== null) {
                        var date = data.split('T')[0];
                        return date;
                    } else {
                        return data;
                    }
                }
            },
            {
                title: "Actions",
                targets:5,
                data: "actions",
                width:'50px',
                render: function(data, type, row, meta){
                    if(row.date_fin){
                        $('#zonage_actions>.zonage-desactivation').show();
                    }else{
                        $('#zonage_actions>.zonage-desactivation').show();
                    }
                    $('#zonage_actions>a').attr('data-id_instance', row.pk);
                    return $('#zonage_actions').html().replace('hidden', '');
                }
            },
        ],
        initComplete: function (settings, json) {
            $('.tabbable #' + nomTableDataTable + '_filter input[type=search]').keyup(function () {
                var table = $tableDataTable.DataTable();
                table.search(
                    jQuery.fn.DataTable.ext.type.search.string(this.value)
                ).draw();
            });
            $('#adm-table-zonage').on('search.dt', function () {
                $('#adm-table-zonage').find('input.switch').lc_switch('Actif', '');
            });
        }
    });
    $(tableZonage).on('processing.dt', function (e, settings, processing) {
        wait.processing(processing, '', '', 0);
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });
}


function validationSelectfieldform(modal, idRoleEvaluation, id, idAccordeon, field) {
    modal.find('[name='+field+']').off('change').on('change', function() {
        var valeur = $(this).val();
        var params = get_donnees(modal,idRoleEvaluation, id, idAccordeon);

        wait.start();
        $.ajax({
            type: "GET",
            url: '/gestion-roles/administration-evaluation/parametre-base-comparaison/check-field/'+field+'/',
            data:params,
            dataType: 'html',
            success: function (response) {
                wait.stop();
                $('#div_id_'+field+' ').replaceWith(response);
                var selectField = $('#div_id_'+field+' ').find('select[name='+field+']');
                    selectField.addClass('revenu-select');
                    if (field =='b91VariableExplicative' && valeur)
                {
                    inserreLigneContrainte(valeur, modal, id,idRoleEvaluation, idAccordeon);
                }
                else
                {
                    initmethodecomparaisonfield(modal, idRoleEvaluation, id, idAccordeon);
                }
            }
        });
    });
}

function initmethodecomparaisonfield(modal, idRoleEvaluation, id, idAccordeon) {
    modal.find('form.bareme-comparaison-contrainte, form.bareme-comparaison-contrainte-rigide').each(function () {
        var conteneur = $(this);
        var estRigide = conteneur.hasClass('bareme-comparaison-contrainte-rigide');
        var prefix = estRigide ? 'contrainte_rigide' : 'contrainte';
        var templateSel = estRigide ? '#empty-form-rigide' : '#empty-form';

        conteneur.find('#ajouter-nouvelle-ligne').off('click').on('click', function() {
            var totalForms = modal.find('#id_' + prefix + '-TOTAL_FORMS');
            var count = parseInt(totalForms.val());
            var tmplMarkup = conteneur.find(templateSel);
            var compiledTmpl = $(tmplMarkup).html().replace(/__prefix__/g, count);
            var tablebody = conteneur.find('.row-parent');
            compiledTmpl = $(compiledTmpl).removeClass('empty-form');
            compiledTmpl=  $(compiledTmpl).attr('id-model-instance', 'None');
            compiledTmpl = $(compiledTmpl).attr('id', 'regresssionsimple-');
            tablebody.append(compiledTmpl);
            totalForms.attr('value', count+1);
            $('#id_' + prefix + '-'+count+'-typeRegroupement').select2();
            initAideContrainteRigide(modal);
        });
    });
    initAideContrainteRigide(modal);
    $('[name*="-typeRegroupement"]').select2();
    initSelect2parametrecomparaison(modal, idRoleEvaluation, id, idAccordeon);
        var modalTrsupr = modal.find(".for-ctrl-suppression");
        modalTrsupr.find('input[type="checkbox"]').off('change').on('change',function () {
        var ctrlIcone = $(this).parent().parent().find('i');
        var ctrlRow = $(this).closest('.row-enfant') ;
        if($(this).is(':checked')) {
            $(ctrlRow).find('input').parent().not('.row-enfant').addClass('suppression-ligne');
            $(ctrlRow).find('input').not('input:hidden').not('.row-enfant').prop('disabled',true);
            ctrlIcone.removeClass('fa-square-o').addClass('fa-check-square-o');
        } else {
            $(ctrlRow).find('input').parent().not('.row-enfant').removeClass('suppression-ligne');
            $(ctrlRow).find('input').not('input:hidden').not('.row-enfant').prop('disabled',false);
            ctrlIcone.removeClass('fa-check-square-o').addClass('fa-square-o');

        }
    });

}

function initAideContrainteRigide(modal) {
    var textes = {
        'identique': "Le comparable doit avoir exactement la même valeur que le sujet. Les champs Valeurs/Min/Max ne s'appliquent pas.",
        'groupe': "Le comparable doit appartenir au même groupe que le sujet. Groupe = liste (HH24,HH25), motif % (HU% = commence par HU) et/ou plage numérique Min à Max. Sujet hors de tout groupe = aucune restriction.",
        'ecart': "Le comparable doit être entre [sujet − Min] et [sujet + Max]. Ex. : Min 20 / Max 20, sujet 113 ⇒ entre 93 et 133. Vide = pas de borne de ce côté.",
        'ecart_pct': "Le comparable doit être entre [sujet − Min %] et [sujet + Max %]. Ex. : Min 10 / Max 10, sujet 113 ⇒ entre 101,7 et 124,3.",
        'plage': "Le comparable doit être entre Min et Max, peu importe le sujet. Min seul = supérieur ou égal à (ex. : superficie Min 100 = plus grande que 100). Max seul = inférieur ou égal à.",
        'valeurs_exclues': "Le comparable ne doit PAS appartenir à l'ensemble défini (liste, motif % et/ou plage Min-Max), peu importe le sujet. Ex. : exclure l'UV JJ01 de toute sélection.",
        'valeurs_permises': "Le comparable DOIT appartenir à l'ensemble défini (liste, motif % et/ou plage Min-Max), peu importe la valeur du sujet. Ex. : HH% = seuls les comparables des UVs commençant par HH sont admissibles.",
        'exclusion': "Les comparables non conformes sont écartés définitivement, même si le nombre devient insuffisant.",
        'priorite': "Les conformes passent toujours en premier ; les non conformes ne servent qu'à compléter en dernier recours."
    };
    var placeholders = {
        'identique':       {valeurs: '—', min: '—',                  max: '—'},
        'groupe':          {valeurs: '',  min: 'de…',                max: 'à…'},
        'ecart':           {valeurs: '—', min: 'écart sous le sujet', max: 'écart au-dessus'},
        'ecart_pct':       {valeurs: '—', min: '% sous le sujet',    max: '% au-dessus'},
        'plage':           {valeurs: '—', min: '≥ (vide = aucun)',   max: '≤ (vide = aucun)'},
        'valeurs_exclues': {valeurs: '',  min: 'de…',                max: 'à…'},
        'valeurs_permises': {valeurs: '',  min: 'de…',                max: 'à…'}
    };
    var selecteurs = 'select[name$="-type_contrainte"], select[name$="-mode"]';

    function majPlaceholders(selectType) {
        var ph = placeholders[selectType.val()] || {valeurs: '', min: '', max: ''};
        var rangee = selectType.closest('.row-enfant');
        rangee.find('input[name$="-valeurs"]').attr('placeholder', ph.valeurs);
        rangee.find('input[name$="-valeur_minimum"]').attr('placeholder', ph.min);
        rangee.find('input[name$="-valeur_maximum"]').attr('placeholder', ph.max);
    }

    function majAide(select, afficher) {
        select = $(select);
        var texte = textes[select.val()] || '';
        select.attr('title', texte).attr('data-original-title', texte);
        // Tooltip natif sur chaque option du menu déroulant : l'explication
        // est visible au survol des choix, avant même de sélectionner.
        select.find('option').each(function () {
            var texteOption = textes[$(this).val()];
            if (texteOption) {
                $(this).attr('title', texteOption);
            }
        });
        if (select.attr('name').indexOf('type_contrainte') !== -1) {
            majPlaceholders(select);
        }
        if (!$.fn.tooltip) {
            return;
        }
        select.tooltip('destroy');
        select.tooltip({container: 'body', placement: 'top', trigger: 'hover focus'});
        if (afficher && texte) {
            select.tooltip('show');
            clearTimeout(select.data('aideRigideTimer'));
            select.data('aideRigideTimer', setTimeout(function () {
                select.tooltip('hide');
            }, 4000));
        }
    }

    modal.find('form.bareme-comparaison-contrainte-rigide').find(selecteurs).each(function () {
        majAide(this, false);
        $(this).off('change.aideRigide').on('change.aideRigide', function () { majAide(this, true); });
    });
    // Initialiser les tooltips des en-têtes présents dans le HTML rechargé par AJAX
    modal.find('[data-toggle="tooltip"]').tooltip();
}

function inserreLigneContrainte(typeCalcul, modal, id,idRoleEvaluation, idAccordeon) {
    var remplacerSousBloc = function (typeSousBloc, formSelector, callback) {
        $.ajax({
            type: "POST",
            url: '/gestion-roles/administration-evaluation/parametre-base-comparaison/nouveau-form-contrainte/',
            data: {'typeCalcul': typeCalcul, 'type_sous_bloc': typeSousBloc},
            dataType: 'html',
            success: function (response) {
                var table = modal.find(formSelector);
                if (table.length) {
                    if (table.find('.form-condo-cadastre').length) {
                        table.find('.form-condo-cadastre').replaceWith(response);
                    } else {
                        $(table).append(response);
                    }
                }
                if (callback) callback();
            }
        });
    };

    wait.start();
    remplacerSousBloc('contrainte', 'form.bareme-comparaison-contrainte', function () {
        remplacerSousBloc('contrainte_rigide', 'form.bareme-comparaison-contrainte-rigide', function () {
            wait.stop();
            initmethodecomparaisonfield(modal, idRoleEvaluation, id, idAccordeon);
        });
    });
}

function get_donnees(modal,idrole, id, idAccordeon) {
    var params = {};
    var data_espace = {};
    var data_espace_detail = {};
    var data_espace_detail_rigide = {};
    serialize_parametre_comparaison(modal.find('form.bareme-comparaison-methode'), data_espace);
    serialize_parametre_comparaison(modal.find('form.bareme-comparaison-contrainte'), data_espace_detail);
    serialize_parametre_comparaison(modal.find('form.bareme-comparaison-contrainte-rigide'), data_espace_detail_rigide);
    params.EspaceLocatifdetail =  JSON.stringify(data_espace_detail);
    params.EspaceLocatifdetailrigide = JSON.stringify(data_espace_detail_rigide);
    params.data_espace = JSON.stringify(data_espace);
    params.id = id;
    params.id_role_evaluation = idrole;
    params.id_accordeon= idAccordeon;
    return params;
}

function serialize_parametre_comparaison(modal, data) {
    modal.serializeArray().map(function (item) {
            data[item.name] = item.value;
    });
}

function initSelect2parametrecomparaison(container, idRoleEvaluation, id, idAccordeon) {
    var inputs = container.find("select.revenu-select");

    $.each(inputs, function (index, input) {
        input = $(input);
            input.select2({
                dropdownAutoWidth: 'true',
                allowClear: true, // DM: pour afficher un X pour permettre de sélectionner "NULL"
                placeholder: ''
            });
        validationSelectfieldform(container, idRoleEvaluation, id, idAccordeon, input.attr('name'));
    });
}



function supprimer_parametre_role_methode_comparaison(a, id, object) {

    var accordeon = $(object).closest('.panel-group');
    var idAccordeon = accordeon.attr('id').substring(10);

    fenetreModal.modalMessage({
        enteteTitre: "Voulez-vous vraiment supprimer ce barème ?",
        texteExplicatif: "<br />ATTENTION: CETTE ACTION EST IRRÉVERSIBLE",
        texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
        sansX: true,
        conteneur: "#page_content",
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    var params = {
                        id: id,
                        id_accordeon: idAccordeon
                    };
                    wait.start();
                    $.ajax({
                        type: "POST",
                        url: '/gestion-roles/administration-evaluation/parametre-base-comparaison/supprimer-methode-bareme-methode-comparaison/',
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop();

                            var callback = function() {
                                wait.stop();
                            };

                            wait.start();
                            refreshDatatables(callback);
                        }
                    });
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });
}

$(document).off("click", ".modal-erreur-validation-close").on("click", ".modal-erreur-validation-close", function() {
    $("#adm-table-erreur-validation").DataTable().destroy();
    $('#modal-erreur-validation').modal('hide');
});


const profilEvaluateurResponsable = {
    /*
    Tous les éléments de profil évaluateur responsable sont gardés ensemble pour faciliter la manipulation et dans
    l'éventualité où on voudrait le déplacer dans son propre fichier pour alléger le fichier administration.js.
     */
    admGetContentProfilEvaluateurResponsable: function (id_organisation) {
        /**
         * Initialise la table des profils évaluateur responsable
         * **/
        const pilotage_profils_evaluateur_responsable_url = '/gestion-roles/administration-evaluation/organisation/pilotage-profils-evaluateur-responsable/'
        const nomTableDataTable = 'adm-table-profils-evaluateur-responsable';
        const $tableDataTable = $('#' + nomTableDataTable);
        const tableProfilsEvaluateurResponsable = initTableDatatable($tableDataTable, {
            ajax: {
                url: pilotage_profils_evaluateur_responsable_url,
                data: function (d) {
                    // d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                }
            },
            paging: false,
            async: false,
            order: [[0, 'asc']],
            processing: false,
            scrollX: false,
            responsive: false,
            searching: true,
            language: {
                emptyTable: "Aucun profil existant. Veuillez créer les profils désirés."
            },
            rowId: 'id_profil_evaluateur_responsable',
            columnDefs: [
                {
                    title: "Nom",
                    targets: 0,
                    data: "nom",
                },
                {
                    title: "Description",
                    targets: 1,
                    data: "description",
                },
                {
                    title: "Notes",
                    targets: 2,
                    data: "note",
                    width: "45%"
                },
                {
                    title: "État",
                    targets: 3,
                    data: "bool_actif",
                    width: "60px",
                    sortable: false,
                },
                {
                    title: 'Actions',
                    targets: 4,
                    data: "actions",
                    width: '50px',
                    sortable: false,
                },
                {
                    targets: 3,
                    data: null,
                    render: function (data, type, row) {
                        /*
                        Pour l'instant, si une personne peut voir la table, elle peut éditer. Si éventuellement
                        on veut un mode read only, il faudra ajouter un paramètre can_edit, comme on peut trouver dans
                        importerDataTableTablePilotage.
                        */
                        const etat = (data == true || data == null) ? 'checked' : '';
                        return '<div class="action-buttons align-middle align-center"><input type="checkbox" name="etat" id-model-instance="' + row.id_profil_evaluateur_responsable + '" class="activer-profil-evaluateur-responsable switch" value="' + data + '" ' + etat + '></div>';
                    }
                },
            ],
            drawCallback: function (settings) {
                $('#adm-table-profils-evaluateur-responsable').find('input.switch').lc_switch('Actif', '');
            },
            initComplete: function (settings, json) {
                // On passe les données de la ligne à l'initEvenementsJQuery pour l'update par l'input switch
                profilEvaluateurResponsable.initEvenementsJQuery(id_organisation);
                $('#id_evaluateurResponsable').select2();
                $('.tabbable #' + nomTableDataTable + '_filter input[type=search]').keyup(function () {
                    const table = $tableDataTable.DataTable();
                    table.search(
                        jQuery.fn.DataTable.ext.type.search.string(this.value)
                    ).draw();
                });
                $('#adm-table-profils-evaluateur-responsable').on('search.dt', function () {
                    $('#adm-table-profils-evaluateur-responsable').find('input.switch').lc_switch('Actif', '');
                });
            }
        })
        $(tableProfilsEvaluateurResponsable).on('processing.dt', function (e, settings, processing) {
            wait.processing(processing, '', '', 0);
            if (processing) {
                wait.start();
            } else {
                wait.stop();
            }
        });
    },

    creerEditerProfilEvaluateurResponsable: function (profil = false, read_only = false) {
        /*
        Pour l'instant, le paramètre "read_only" sera toujours à false, car si un utilisateur peut voir la page, c'est
        qu'il peut l'éditer. Le "ground work" est cependant là pour faciliter la tâche si jamais on veut
        implémenter le read only pour cette section.
        */
        const organisationId = $('#content-pilotage-profils-evaluateur-responsable').data('organisation')
        let idProfilEvaluateurResponsable = '';
        if (profil) {
            idProfilEvaluateurResponsable = profil + '/';
        }
        const formProfilEvaluateurResponsable = {
            read_only: read_only,
            idProfilEvaluateurResponsable: profil,
            id: "profil-evaluateur-responsable",
            view: "/core/modal/",
            processus_id: "",
            titre: idProfilEvaluateurResponsable ? "Éditer profil évaluateur responsable" : "Nouveau profil évaluateur responsable",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template: "",
            template_view: "/gestion-roles/administration-evaluation/organisation/pilotage-profils-evaluateur-responsable/form/" + idProfilEvaluateurResponsable,
            template_depart: "",
            sans_x: false,
            template_depart_view: "",
            url: "",
            taille: "normal",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            boutons: [
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
                {
                    type: "delete",
                    label: "Supprimer",
                    title: "",
                    classSupp: "",
                    afficher: Boolean(!read_only && profil),
                    id: "btn-supprimer-profil-evaluateur-responsable",
                },
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "",
                    classSupp: "btn-primary",
                    afficher: !read_only,
                    id: "btn-save-modal-profil-evaluateur-responsable",
                    disabled: false
                },
            ]
        };

        setTimeout(function () {
            const callbacks = [
                function () {
                    controlesFormulaires.redimentionnerTextarea();
                },
                function () {
                    $('body').off('click', '#btn-save-modal-profil-evaluateur-responsable').on('click', '#btn-save-modal-profil-evaluateur-responsable', function (e) {
                        const methode = 'POST';
                        const parametres = [{'name': 'methode', 'value': methode}];
                        profilEvaluateurResponsable.sauvegarderProfilEvaluateurResponsable(parametres, organisationId);
                    })
                    $('body').off('click', '#btn-supprimer-profil-evaluateur-responsable').on('click', '#btn-supprimer-profil-evaluateur-responsable', function (e) {
                        profilEvaluateurResponsable.modalSupprimerProfilEvaluateurResponsable(idProfilEvaluateurResponsable)
                    });

                },
            ];
            fenetreModal.creerModal(formProfilEvaluateurResponsable, {}, callbacks);
        }, 0);
    },

    sauvegarderProfilEvaluateurResponsable: function (paramsSupplementaires, organisationId) {
        wait.start()
        let params = [{'name': 'id_organisation', 'value': organisationId}];
        let id;

        if (estKeyInArrayOfObjects(paramsSupplementaires, 'bool')) {
            let bool_actif = reqValeurKeyInArrayOfObjects((paramsSupplementaires), 'bool').value === 'lcs_on' ? true : false
            params.push({'name': 'bool_actif', 'value': bool_actif});
            id = reqValeurKeyInArrayOfObjects(paramsSupplementaires, 'id').value;
        } else {
            id = $('#profil-evaluateur-responsable-modale').attr('id-model-instance');
            const formulaireDonnees = controlesFormulaires.serialiserFormulaire($('#profil-evaluateur-responsable-modale'));
            params = params.concat(formulaireDonnees);
        }
        params = params.concat(paramsSupplementaires)
        const element = id !== 'None' ? encodeURIComponent(id) + '/' : '';
        const jqxhr = $.ajax({
            url: "/gestion-roles/administration-evaluation/organisation/pilotage-profils-evaluateur-responsable/form/" + element,
            async: false,
            type: reqValeurKeyInArrayOfObjects(paramsSupplementaires, 'methode').value,
            dataType: 'json',
            data: params
        });
        jqxhr
            .done(function (response) {
                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });
                refreshDatatables(function () {
                    if ($('#profil-evaluateur-responsable').length > 0) {
                        fenetreModal.fermerModal('profil-evaluateur-responsable');
                    }
                    wait.stop();
                    $('#adm-table-profils-evaluateur-responsable.switch').lc_switch('Actif', '');
                });
            });
        jqxhr
            .fail(function (xhr) {
                infos.ajouterMessageToast({
                    message: "Erreur de sauvegarde",
                    messageCouleur: "red",
                    messageDuree: 500,
                    type: 'error'
                });
                $('#profil-evaluateur-responsable-modale').html(xhr.responseJSON.form);
                wait.stop();
            });
    },

    initEvenementsJQuery: function (organisationId) {
        $('#adm-table-profils-evaluateur-responsable').off("click", 'div.lcs_switch:not(".lcs_disabled")').on("click", 'div.lcs_switch:not(".lcs_disabled")', function (e) {
            const valeur = $(this).hasClass('lcs_on') ? 'lcs_off' : 'lcs_on';
            const id_profil = $(e.target).closest('tr').attr('id');
            const parametres = [
                {'name': 'methode', 'value': 'POST'},
                {'name': 'bool', 'value': valeur},
                {'name': 'id', 'value': id_profil},
            ];
            profilEvaluateurResponsable.sauvegarderProfilEvaluateurResponsable(parametres, organisationId);
        });
        $('body').off('click', '#btn-save-modal-profil-evaluateur-responsable').on('click', '#btn-save-modal-profil-evaluateur-responsable', function (e) {
            const methode = 'POST';
            const parametres = [{'name': 'methode', 'value': methode}];
            profilEvaluateurResponsable.sauvegarderProfilEvaluateurResponsable(parametres, organisationId);
        });
    },

    modalSupprimerProfilEvaluateurResponsable: function (idProfil) {
        const variableSupprimerProfilEvaluateurResponsable = {
            id: "profil-evaluateur-responsable-supprimer-modale",
            view: "/core/modal/",
            id_processus: "",
            titre: "Souhaitez-vous vraiment supprimer ce profil évaluateur responsable?",
            titre_supp: "",
            module: "",
            contenuHTML: '<h5 class="modal-title red vertical-align-middle">Les données seront détruites de façon permanente</h5><p>',
            contenuIcone: 'fa-exclamation-triangle orange vertical-align-middle',
            template: "",
            template_view: "",
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "normale",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            sans_x: false,
            callback: function (e) {
                setTimeout(function () {
                    $('#proceder-supprimer-profil-evaluateur-responsable').off('click').on('click', function () {
                        profilEvaluateurResponsable.modalSupprimerProfilEvaluateurResponsableConfirmed(idProfil);
                    });
                }, 100);
            },
            boutons: [
                {
                    type: "delete",
                    label: "Oui",
                    title: "",
                    classSupp: "btn-danger",
                    afficher: true,
                    id: "proceder-supprimer-profil-evaluateur-responsable",
                },
                {
                    type: "cancel",
                    label: "Non",
                    title: "",
                    classSupp: "",
                    afficher: true
                }
            ]
        };

        setTimeout(function () {
            fenetreModal.creerModal(variableSupprimerProfilEvaluateurResponsable, {});
        }, 100);
    },

    modalSupprimerProfilEvaluateurResponsableConfirmed: function (idProfilEvaluateurResponsable) {
        wait.start();
        const jqxhr = $.ajax({
            type: "DELETE",
            url: "/gestion-roles/administration-evaluation/organisation/pilotage-profils-evaluateur-responsable/form/" + idProfilEvaluateurResponsable,
            dataType: 'html',
        });
        jqxhr
            .done(function (response) {
                refreshDatatables()
                fenetreModal.fermerModal("profil-evaluateur-responsable-supprimer-modale");
                fenetreModal.fermerModal("profil-evaluateur-responsable");
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: "Le profil a bien été supprimé",
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green',
                    messageDuree: 500
                });
                wait.stop();
            });
        jqxhr
            .fail(function (xhr) {
                if (xhr.status === 422) {
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', xhr.responseText);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: 'Impossible de supprimer le profil',
                        messageCouleur: 'red',
                        messageDuree: 1500
                    });
                } else if (xhr.responseText !== '') {
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', xhr.responseText);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: 'Erreur de suppression',
                        messageCouleur: 'red',
                        messageDuree: 1500
                    });
                } else {
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: 'Une erreur inattendue s\'est produite',
                        messageCouleur: 'red',
                        messageDuree: 1500
                    });
                }
                $('#proceder-supprimer-evenement').remove();
                wait.stop();
            });
    },
}
